export default [
{
"id": 194898737,
"node_id": "MDEwOlJlcG9zaXRvcnkxOTQ4OTg3Mzc=",
"name": ".github",
"full_name": "microsoft/.github",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/.github",
"description": "Default Community Health Files for the Microsoft organization on GitHub",
"fork": false,
"url": "https://api.github.com/repos/microsoft/.github",
"forks_url": "https://api.github.com/repos/microsoft/.github/forks",
"keys_url": "https://api.github.com/repos/microsoft/.github/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/.github/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/.github/teams",
"hooks_url": "https://api.github.com/repos/microsoft/.github/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/.github/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/.github/events",
"assignees_url": "https://api.github.com/repos/microsoft/.github/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/.github/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/.github/tags",
"blobs_url": "https://api.github.com/repos/microsoft/.github/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/.github/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/.github/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/.github/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/.github/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/.github/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/.github/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/.github/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/.github/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/.github/subscription",
"commits_url": "https://api.github.com/repos/microsoft/.github/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/.github/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/.github/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/.github/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/.github/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/.github/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/.github/merges",
"archive_url": "https://api.github.com/repos/microsoft/.github/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/.github/downloads",
"issues_url": "https://api.github.com/repos/microsoft/.github/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/.github/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/.github/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/.github/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/.github/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/.github/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/.github/deployments",
"created_at": "2019-07-02T16:27:27Z",
"updated_at": "2021-08-13T14:04:39Z",
"pushed_at": "2021-08-19T00:16:02Z",
"git_url": "git://github.com/microsoft/.github.git",
"ssh_url": "git@github.com:microsoft/.github.git",
"clone_url": "https://github.com/microsoft/.github.git",
"svn_url": "https://github.com/microsoft/.github",
"homepage": null,
"size": 2,
"stargazers_count": 16,
"watchers_count": 16,
"language": null,
"has_issues": false,
"has_projects": false,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 67,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 67,
"open_issues": 0,
"watchers": 16,
"default_branch": "main"
},
{
"id": 342423762,
"node_id": "MDEwOlJlcG9zaXRvcnkzNDI0MjM3NjI=",
"name": ".Net-Interactive-Kernels-ADS",
"full_name": "microsoft/.Net-Interactive-Kernels-ADS",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/.Net-Interactive-Kernels-ADS",
"description": "Install and Use .Net Interactive Kernels in ADS",
"fork": false,
"url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS",
"forks_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/forks",
"keys_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/teams",
"hooks_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/events",
"assignees_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/tags",
"blobs_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/subscription",
"commits_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/merges",
"archive_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/downloads",
"issues_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/.Net-Interactive-Kernels-ADS/deployments",
"created_at": "2021-02-26T01:06:58Z",
"updated_at": "2021-08-19T22:40:28Z",
"pushed_at": "2021-05-18T20:08:46Z",
"git_url": "git://github.com/microsoft/.Net-Interactive-Kernels-ADS.git",
"ssh_url": "git@github.com:microsoft/.Net-Interactive-Kernels-ADS.git",
"clone_url": "https://github.com/microsoft/.Net-Interactive-Kernels-ADS.git",
"svn_url": "https://github.com/microsoft/.Net-Interactive-Kernels-ADS",
"homepage": null,
"size": 6699,
"stargazers_count": 2,
"watchers_count": 2,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 1,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 1,
"open_issues": 0,
"watchers": 2,
"default_branch": "main"
},
{
"id": 255536764,
"node_id": "MDEwOlJlcG9zaXRvcnkyNTU1MzY3NjQ=",
"name": ".NET-Modernization-In-a-Day",
"full_name": "microsoft/.NET-Modernization-In-a-Day",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/.NET-Modernization-In-a-Day",
"description": ".NET Modernization In a Day workshop content",
"fork": false,
"url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day",
"forks_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/forks",
"keys_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/teams",
"hooks_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/events",
"assignees_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/tags",
"blobs_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/subscription",
"commits_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/merges",
"archive_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/downloads",
"issues_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/.NET-Modernization-In-a-Day/deployments",
"created_at": "2020-04-14T07:12:21Z",
"updated_at": "2021-06-24T07:54:14Z",
"pushed_at": "2021-05-17T09:33:16Z",
"git_url": "git://github.com/microsoft/.NET-Modernization-In-a-Day.git",
"ssh_url": "git@github.com:microsoft/.NET-Modernization-In-a-Day.git",
"clone_url": "https://github.com/microsoft/.NET-Modernization-In-a-Day.git",
"svn_url": "https://github.com/microsoft/.NET-Modernization-In-a-Day",
"homepage": null,
"size": 85874,
"stargazers_count": 37,
"watchers_count": 37,
"language": "JavaScript",
"has_issues": true,
"has_projects": false,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 41,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 14,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 41,
"open_issues": 14,
"watchers": 37,
"default_branch": "master"
},
{
"id": 181561897,
"node_id": "MDEwOlJlcG9zaXRvcnkxODE1NjE4OTc=",
"name": "0xDeCA10B",
"full_name": "microsoft/0xDeCA10B",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/0xDeCA10B",
"description": "Sharing Updatable Models (SUM) on Blockchain",
"fork": false,
"url": "https://api.github.com/repos/microsoft/0xDeCA10B",
"forks_url": "https://api.github.com/repos/microsoft/0xDeCA10B/forks",
"keys_url": "https://api.github.com/repos/microsoft/0xDeCA10B/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/0xDeCA10B/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/0xDeCA10B/teams",
"hooks_url": "https://api.github.com/repos/microsoft/0xDeCA10B/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/0xDeCA10B/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/0xDeCA10B/events",
"assignees_url": "https://api.github.com/repos/microsoft/0xDeCA10B/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/0xDeCA10B/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/0xDeCA10B/tags",
"blobs_url": "https://api.github.com/repos/microsoft/0xDeCA10B/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/0xDeCA10B/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/0xDeCA10B/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/0xDeCA10B/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/0xDeCA10B/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/0xDeCA10B/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/0xDeCA10B/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/0xDeCA10B/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/0xDeCA10B/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/0xDeCA10B/subscription",
"commits_url": "https://api.github.com/repos/microsoft/0xDeCA10B/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/0xDeCA10B/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/0xDeCA10B/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/0xDeCA10B/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/0xDeCA10B/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/0xDeCA10B/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/0xDeCA10B/merges",
"archive_url": "https://api.github.com/repos/microsoft/0xDeCA10B/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/0xDeCA10B/downloads",
"issues_url": "https://api.github.com/repos/microsoft/0xDeCA10B/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/0xDeCA10B/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/0xDeCA10B/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/0xDeCA10B/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/0xDeCA10B/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/0xDeCA10B/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/0xDeCA10B/deployments",
"created_at": "2019-04-15T20:37:11Z",
"updated_at": "2021-08-19T08:47:20Z",
"pushed_at": "2021-07-13T20:26:50Z",
"git_url": "git://github.com/microsoft/0xDeCA10B.git",
"ssh_url": "git@github.com:microsoft/0xDeCA10B.git",
"clone_url": "https://github.com/microsoft/0xDeCA10B.git",
"svn_url": "https://github.com/microsoft/0xDeCA10B",
"homepage": "https://aka.ms/0xDeCA10B-blog1",
"size": 14895,
"stargazers_count": 347,
"watchers_count": 347,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 68,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 10,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 68,
"open_issues": 10,
"watchers": 347,
"default_branch": "main"
},
{
"id": 214504654,
"node_id": "MDEwOlJlcG9zaXRvcnkyMTQ1MDQ2NTQ=",
"name": "2019-ignite-circuit-playground",
"full_name": "microsoft/2019-ignite-circuit-playground",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/2019-ignite-circuit-playground",
"description": "Get started with Circuit Playground Express and the Device Simulator Express",
"fork": false,
"url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground",
"forks_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/forks",
"keys_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/teams",
"hooks_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/events",
"assignees_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/tags",
"blobs_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/subscription",
"commits_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/merges",
"archive_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/downloads",
"issues_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/2019-ignite-circuit-playground/deployments",
"created_at": "2019-10-11T18:28:11Z",
"updated_at": "2021-05-07T13:48:29Z",
"pushed_at": "2019-11-04T23:55:01Z",
"git_url": "git://github.com/microsoft/2019-ignite-circuit-playground.git",
"ssh_url": "git@github.com:microsoft/2019-ignite-circuit-playground.git",
"clone_url": "https://github.com/microsoft/2019-ignite-circuit-playground.git",
"svn_url": "https://github.com/microsoft/2019-ignite-circuit-playground",
"homepage": null,
"size": 218,
"stargazers_count": 8,
"watchers_count": 8,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 7,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 7,
"open_issues": 0,
"watchers": 8,
"default_branch": "master"
},
{
"id": 224439081,
"node_id": "MDEwOlJlcG9zaXRvcnkyMjQ0MzkwODE=",
"name": "25-days-of-serverless",
"full_name": "microsoft/25-days-of-serverless",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/25-days-of-serverless",
"description": "Repository responsible for 25 days of Serverless challenges",
"fork": false,
"url": "https://api.github.com/repos/microsoft/25-days-of-serverless",
"forks_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/forks",
"keys_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/teams",
"hooks_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/events",
"assignees_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/tags",
"blobs_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/subscription",
"commits_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/merges",
"archive_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/downloads",
"issues_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/25-days-of-serverless/deployments",
"created_at": "2019-11-27T13:38:11Z",
"updated_at": "2021-07-30T04:47:18Z",
"pushed_at": "2020-11-11T08:31:54Z",
"git_url": "git://github.com/microsoft/25-days-of-serverless.git",
"ssh_url": "git@github.com:microsoft/25-days-of-serverless.git",
"clone_url": "https://github.com/microsoft/25-days-of-serverless.git",
"svn_url": "https://github.com/microsoft/25-days-of-serverless",
"homepage": "https://aka.ms/25DaysOfServerless",
"size": 242,
"stargazers_count": 406,
"watchers_count": 406,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 136,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 8,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 136,
"open_issues": 8,
"watchers": 406,
"default_branch": "master"
},
{
"id": 223094600,
"node_id": "MDEwOlJlcG9zaXRvcnkyMjMwOTQ2MDA=",
"name": "2D-TAN",
"full_name": "microsoft/2D-TAN",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/2D-TAN",
"description": "AAAI‘20 - Learning 2D Temporal Localization Networks for Moment Localization with Natural Language",
"fork": false,
"url": "https://api.github.com/repos/microsoft/2D-TAN",
"forks_url": "https://api.github.com/repos/microsoft/2D-TAN/forks",
"keys_url": "https://api.github.com/repos/microsoft/2D-TAN/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/2D-TAN/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/2D-TAN/teams",
"hooks_url": "https://api.github.com/repos/microsoft/2D-TAN/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/2D-TAN/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/2D-TAN/events",
"assignees_url": "https://api.github.com/repos/microsoft/2D-TAN/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/2D-TAN/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/2D-TAN/tags",
"blobs_url": "https://api.github.com/repos/microsoft/2D-TAN/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/2D-TAN/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/2D-TAN/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/2D-TAN/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/2D-TAN/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/2D-TAN/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/2D-TAN/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/2D-TAN/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/2D-TAN/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/2D-TAN/subscription",
"commits_url": "https://api.github.com/repos/microsoft/2D-TAN/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/2D-TAN/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/2D-TAN/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/2D-TAN/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/2D-TAN/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/2D-TAN/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/2D-TAN/merges",
"archive_url": "https://api.github.com/repos/microsoft/2D-TAN/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/2D-TAN/downloads",
"issues_url": "https://api.github.com/repos/microsoft/2D-TAN/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/2D-TAN/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/2D-TAN/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/2D-TAN/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/2D-TAN/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/2D-TAN/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/2D-TAN/deployments",
"created_at": "2019-11-21T05:22:17Z",
"updated_at": "2021-08-16T11:47:29Z",
"pushed_at": "2021-05-23T14:03:28Z",
"git_url": "git://github.com/microsoft/2D-TAN.git",
"ssh_url": "git@github.com:microsoft/2D-TAN.git",
"clone_url": "https://github.com/microsoft/2D-TAN.git",
"svn_url": "https://github.com/microsoft/2D-TAN",
"homepage": null,
"size": 4971,
"stargazers_count": 170,
"watchers_count": 170,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 43,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 3,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 43,
"open_issues": 3,
"watchers": 170,
"default_branch": "master"
},
{
"id": 123261435,
"node_id": "MDEwOlJlcG9zaXRvcnkxMjMyNjE0MzU=",
"name": "2LCS",
"full_name": "microsoft/2LCS",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/2LCS",
"description": "Lifecycle Services Companion App for administrators",
"fork": false,
"url": "https://api.github.com/repos/microsoft/2LCS",
"forks_url": "https://api.github.com/repos/microsoft/2LCS/forks",
"keys_url": "https://api.github.com/repos/microsoft/2LCS/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/2LCS/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/2LCS/teams",
"hooks_url": "https://api.github.com/repos/microsoft/2LCS/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/2LCS/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/2LCS/events",
"assignees_url": "https://api.github.com/repos/microsoft/2LCS/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/2LCS/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/2LCS/tags",
"blobs_url": "https://api.github.com/repos/microsoft/2LCS/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/2LCS/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/2LCS/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/2LCS/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/2LCS/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/2LCS/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/2LCS/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/2LCS/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/2LCS/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/2LCS/subscription",
"commits_url": "https://api.github.com/repos/microsoft/2LCS/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/2LCS/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/2LCS/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/2LCS/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/2LCS/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/2LCS/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/2LCS/merges",
"archive_url": "https://api.github.com/repos/microsoft/2LCS/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/2LCS/downloads",
"issues_url": "https://api.github.com/repos/microsoft/2LCS/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/2LCS/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/2LCS/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/2LCS/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/2LCS/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/2LCS/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/2LCS/deployments",
"created_at": "2018-02-28T09:24:33Z",
"updated_at": "2021-07-12T02:40:04Z",
"pushed_at": "2021-07-09T16:06:29Z",
"git_url": "git://github.com/microsoft/2LCS.git",
"ssh_url": "git@github.com:microsoft/2LCS.git",
"clone_url": "https://github.com/microsoft/2LCS.git",
"svn_url": "https://github.com/microsoft/2LCS",
"homepage": null,
"size": 736,
"stargazers_count": 77,
"watchers_count": 77,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 32,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 5,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 32,
"open_issues": 5,
"watchers": 77,
"default_branch": "master"
},
{
"id": 38279022,
"node_id": "MDEwOlJlcG9zaXRvcnkzODI3OTAyMg==",
"name": "3-in-1-dock",
"full_name": "microsoft/3-in-1-dock",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/3-in-1-dock",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/3-in-1-dock",
"forks_url": "https://api.github.com/repos/microsoft/3-in-1-dock/forks",
"keys_url": "https://api.github.com/repos/microsoft/3-in-1-dock/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/3-in-1-dock/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/3-in-1-dock/teams",
"hooks_url": "https://api.github.com/repos/microsoft/3-in-1-dock/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/3-in-1-dock/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/3-in-1-dock/events",
"assignees_url": "https://api.github.com/repos/microsoft/3-in-1-dock/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/3-in-1-dock/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/3-in-1-dock/tags",
"blobs_url": "https://api.github.com/repos/microsoft/3-in-1-dock/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/3-in-1-dock/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/3-in-1-dock/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/3-in-1-dock/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/3-in-1-dock/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/3-in-1-dock/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/3-in-1-dock/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/3-in-1-dock/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/3-in-1-dock/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/3-in-1-dock/subscription",
"commits_url": "https://api.github.com/repos/microsoft/3-in-1-dock/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/3-in-1-dock/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/3-in-1-dock/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/3-in-1-dock/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/3-in-1-dock/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/3-in-1-dock/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/3-in-1-dock/merges",
"archive_url": "https://api.github.com/repos/microsoft/3-in-1-dock/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/3-in-1-dock/downloads",
"issues_url": "https://api.github.com/repos/microsoft/3-in-1-dock/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/3-in-1-dock/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/3-in-1-dock/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/3-in-1-dock/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/3-in-1-dock/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/3-in-1-dock/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/3-in-1-dock/deployments",
"created_at": "2015-06-30T00:43:54Z",
"updated_at": "2021-06-15T14:43:39Z",
"pushed_at": "2016-10-20T21:06:46Z",
"git_url": "git://github.com/microsoft/3-in-1-dock.git",
"ssh_url": "git@github.com:microsoft/3-in-1-dock.git",
"clone_url": "https://github.com/microsoft/3-in-1-dock.git",
"svn_url": "https://github.com/microsoft/3-in-1-dock",
"homepage": null,
"size": 6758,
"stargazers_count": 51,
"watchers_count": 51,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 20,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 20,
"open_issues": 0,
"watchers": 51,
"default_branch": "master"
},
{
"id": 265093175,
"node_id": "MDEwOlJlcG9zaXRvcnkyNjUwOTMxNzU=",
"name": "A-TALE-OF-THREE-CITIES",
"full_name": "microsoft/A-TALE-OF-THREE-CITIES",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/A-TALE-OF-THREE-CITIES",
"description": "Analyzing the safety (311) dataset published by Azure Open Datasets for Chicago, Boston and New York City using SparkR, SParkSQL, Azure Databricks, visualization using ggplot2 and leaflet. Focus is on descriptive analytics, visualization, clustering, time series forecasting and anomaly detection.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES",
"forks_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/forks",
"keys_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/teams",
"hooks_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/events",
"assignees_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/tags",
"blobs_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/subscription",
"commits_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/merges",
"archive_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/downloads",
"issues_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/A-TALE-OF-THREE-CITIES/deployments",
"created_at": "2020-05-18T23:59:05Z",
"updated_at": "2021-07-04T12:55:40Z",
"pushed_at": "2021-05-03T20:14:01Z",
"git_url": "git://github.com/microsoft/A-TALE-OF-THREE-CITIES.git",
"ssh_url": "git@github.com:microsoft/A-TALE-OF-THREE-CITIES.git",
"clone_url": "https://github.com/microsoft/A-TALE-OF-THREE-CITIES.git",
"svn_url": "https://github.com/microsoft/A-TALE-OF-THREE-CITIES",
"homepage": "https://github.com/microsoft/A-TALE-OF-THREE-CITIES",
"size": 22814,
"stargazers_count": 4,
"watchers_count": 4,
"language": "R",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 4,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 4,
"open_issues": 0,
"watchers": 4,
"default_branch": "master"
},
{
"id": 376848872,
"node_id": "MDEwOlJlcG9zaXRvcnkzNzY4NDg4NzI=",
"name": "aaai21-copy-that",
"full_name": "microsoft/aaai21-copy-that",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aaai21-copy-that",
"description": "Source code for the `Copy that! Editing Sequences by Copying Spans ,AAAI'21 paper",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aaai21-copy-that",
"forks_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/forks",
"keys_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/events",
"assignees_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/merges",
"archive_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aaai21-copy-that/deployments",
"created_at": "2021-06-14T14:17:22Z",
"updated_at": "2021-07-28T14:06:03Z",
"pushed_at": "2021-06-14T14:34:00Z",
"git_url": "git://github.com/microsoft/aaai21-copy-that.git",
"ssh_url": "git@github.com:microsoft/aaai21-copy-that.git",
"clone_url": "https://github.com/microsoft/aaai21-copy-that.git",
"svn_url": "https://github.com/microsoft/aaai21-copy-that",
"homepage": null,
"size": 67,
"stargazers_count": 2,
"watchers_count": 2,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 0,
"watchers": 2,
"default_branch": "main"
},
{
"id": 146294473,
"node_id": "MDEwOlJlcG9zaXRvcnkxNDYyOTQ0NzM=",
"name": "aad-hybrid-lab",
"full_name": "microsoft/aad-hybrid-lab",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aad-hybrid-lab",
"description": "Create a new VM with AD installed, test users created, PowerShell Azure AD modules, and Azure AD Connect installer ready to go.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aad-hybrid-lab",
"forks_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/forks",
"keys_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/events",
"assignees_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/merges",
"archive_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aad-hybrid-lab/deployments",
"created_at": "2018-08-27T12:28:59Z",
"updated_at": "2021-07-26T14:49:25Z",
"pushed_at": "2020-10-14T17:47:52Z",
"git_url": "git://github.com/microsoft/aad-hybrid-lab.git",
"ssh_url": "git@github.com:microsoft/aad-hybrid-lab.git",
"clone_url": "https://github.com/microsoft/aad-hybrid-lab.git",
"svn_url": "https://github.com/microsoft/aad-hybrid-lab",
"homepage": null,
"size": 600,
"stargazers_count": 22,
"watchers_count": 22,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 33,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 33,
"open_issues": 0,
"watchers": 22,
"default_branch": "master"
},
{
"id": 356332292,
"node_id": "MDEwOlJlcG9zaXRvcnkzNTYzMzIyOTI=",
"name": "aadb2c-starter-kit",
"full_name": "microsoft/aadb2c-starter-kit",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aadb2c-starter-kit",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit",
"forks_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/forks",
"keys_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/events",
"assignees_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/merges",
"archive_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aadb2c-starter-kit/deployments",
"created_at": "2021-04-09T16:20:52Z",
"updated_at": "2021-08-10T04:48:12Z",
"pushed_at": "2021-08-13T01:01:19Z",
"git_url": "git://github.com/microsoft/aadb2c-starter-kit.git",
"ssh_url": "git@github.com:microsoft/aadb2c-starter-kit.git",
"clone_url": "https://github.com/microsoft/aadb2c-starter-kit.git",
"svn_url": "https://github.com/microsoft/aadb2c-starter-kit",
"homepage": null,
"size": 1325,
"stargazers_count": 3,
"watchers_count": 3,
"language": "JavaScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 1,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 6,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 1,
"open_issues": 6,
"watchers": 3,
"default_branch": "main"
},
{
"id": 57305206,
"node_id": "MDEwOlJlcG9zaXRvcnk1NzMwNTIwNg==",
"name": "AADConnectConfigDocumenter",
"full_name": "microsoft/AADConnectConfigDocumenter",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AADConnectConfigDocumenter",
"description": "AAD Connect configuration documenter is a tool to generate documentation of an AAD Connect installation.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter",
"forks_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/forks",
"keys_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/events",
"assignees_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/merges",
"archive_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AADConnectConfigDocumenter/deployments",
"created_at": "2016-04-28T13:46:09Z",
"updated_at": "2021-08-19T08:28:40Z",
"pushed_at": "2020-09-17T20:09:14Z",
"git_url": "git://github.com/microsoft/AADConnectConfigDocumenter.git",
"ssh_url": "git@github.com:microsoft/AADConnectConfigDocumenter.git",
"clone_url": "https://github.com/microsoft/AADConnectConfigDocumenter.git",
"svn_url": "https://github.com/microsoft/AADConnectConfigDocumenter",
"homepage": null,
"size": 6216,
"stargazers_count": 160,
"watchers_count": 160,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 37,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 37,
"open_issues": 2,
"watchers": 160,
"default_branch": "master"
},
{
"id": 162219743,
"node_id": "MDEwOlJlcG9zaXRvcnkxNjIyMTk3NDM=",
"name": "AaronLocker",
"full_name": "microsoft/AaronLocker",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AaronLocker",
"description": "Robust and practical application control for Windows",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AaronLocker",
"forks_url": "https://api.github.com/repos/microsoft/AaronLocker/forks",
"keys_url": "https://api.github.com/repos/microsoft/AaronLocker/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AaronLocker/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AaronLocker/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AaronLocker/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AaronLocker/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AaronLocker/events",
"assignees_url": "https://api.github.com/repos/microsoft/AaronLocker/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AaronLocker/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AaronLocker/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AaronLocker/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AaronLocker/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AaronLocker/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AaronLocker/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AaronLocker/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AaronLocker/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AaronLocker/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AaronLocker/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AaronLocker/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AaronLocker/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AaronLocker/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AaronLocker/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AaronLocker/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AaronLocker/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AaronLocker/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AaronLocker/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AaronLocker/merges",
"archive_url": "https://api.github.com/repos/microsoft/AaronLocker/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AaronLocker/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AaronLocker/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AaronLocker/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AaronLocker/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AaronLocker/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AaronLocker/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AaronLocker/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AaronLocker/deployments",
"created_at": "2018-12-18T02:41:00Z",
"updated_at": "2021-08-22T11:06:19Z",
"pushed_at": "2020-06-30T21:29:38Z",
"git_url": "git://github.com/microsoft/AaronLocker.git",
"ssh_url": "git@github.com:microsoft/AaronLocker.git",
"clone_url": "https://github.com/microsoft/AaronLocker.git",
"svn_url": "https://github.com/microsoft/AaronLocker",
"homepage": "",
"size": 4330,
"stargazers_count": 376,
"watchers_count": 376,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 58,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 9,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 58,
"open_issues": 9,
"watchers": 376,
"default_branch": "master"
},
{
"id": 124694095,
"node_id": "MDEwOlJlcG9zaXRvcnkxMjQ2OTQwOTU=",
"name": "ABAP-SDK-for-Azure",
"full_name": "microsoft/ABAP-SDK-for-Azure",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ABAP-SDK-for-Azure",
"description": "ABAP Libraries for SAP native Integration with Azure Services",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure",
"forks_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/forks",
"keys_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/events",
"assignees_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/merges",
"archive_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ABAP-SDK-for-Azure/deployments",
"created_at": "2018-03-10T20:01:50Z",
"updated_at": "2021-07-29T03:02:27Z",
"pushed_at": "2021-07-16T10:04:55Z",
"git_url": "git://github.com/microsoft/ABAP-SDK-for-Azure.git",
"ssh_url": "git@github.com:microsoft/ABAP-SDK-for-Azure.git",
"clone_url": "https://github.com/microsoft/ABAP-SDK-for-Azure.git",
"svn_url": "https://github.com/microsoft/ABAP-SDK-for-Azure",
"homepage": null,
"size": 18022,
"stargazers_count": 106,
"watchers_count": 106,
"language": "ABAP",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 44,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 11,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 44,
"open_issues": 11,
"watchers": 106,
"default_branch": "master"
},
{
"id": 204974165,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDQ5NzQxNjU=",
"name": "ability-attributes",
"full_name": "microsoft/ability-attributes",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ability-attributes",
"description": "Web Application Accessibility Attributes Runtime Validator",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ability-attributes",
"forks_url": "https://api.github.com/repos/microsoft/ability-attributes/forks",
"keys_url": "https://api.github.com/repos/microsoft/ability-attributes/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ability-attributes/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ability-attributes/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ability-attributes/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ability-attributes/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ability-attributes/events",
"assignees_url": "https://api.github.com/repos/microsoft/ability-attributes/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ability-attributes/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ability-attributes/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ability-attributes/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ability-attributes/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ability-attributes/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ability-attributes/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ability-attributes/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ability-attributes/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ability-attributes/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ability-attributes/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ability-attributes/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ability-attributes/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ability-attributes/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ability-attributes/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ability-attributes/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ability-attributes/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ability-attributes/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ability-attributes/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ability-attributes/merges",
"archive_url": "https://api.github.com/repos/microsoft/ability-attributes/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ability-attributes/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ability-attributes/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ability-attributes/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ability-attributes/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ability-attributes/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ability-attributes/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ability-attributes/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ability-attributes/deployments",
"created_at": "2019-08-28T16:17:49Z",
"updated_at": "2021-06-15T14:46:25Z",
"pushed_at": "2020-05-11T00:36:16Z",
"git_url": "git://github.com/microsoft/ability-attributes.git",
"ssh_url": "git@github.com:microsoft/ability-attributes.git",
"clone_url": "https://github.com/microsoft/ability-attributes.git",
"svn_url": "https://github.com/microsoft/ability-attributes",
"homepage": null,
"size": 144,
"stargazers_count": 3,
"watchers_count": 3,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 1,
"watchers": 3,
"default_branch": "master"
},
{
"id": 205781888,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDU3ODE4ODg=",
"name": "abstrakt",
"full_name": "microsoft/abstrakt",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/abstrakt",
"description": "Business oriented, config driven DevOps",
"fork": false,
"url": "https://api.github.com/repos/microsoft/abstrakt",
"forks_url": "https://api.github.com/repos/microsoft/abstrakt/forks",
"keys_url": "https://api.github.com/repos/microsoft/abstrakt/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/abstrakt/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/abstrakt/teams",
"hooks_url": "https://api.github.com/repos/microsoft/abstrakt/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/abstrakt/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/abstrakt/events",
"assignees_url": "https://api.github.com/repos/microsoft/abstrakt/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/abstrakt/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/abstrakt/tags",
"blobs_url": "https://api.github.com/repos/microsoft/abstrakt/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/abstrakt/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/abstrakt/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/abstrakt/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/abstrakt/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/abstrakt/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/abstrakt/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/abstrakt/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/abstrakt/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/abstrakt/subscription",
"commits_url": "https://api.github.com/repos/microsoft/abstrakt/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/abstrakt/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/abstrakt/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/abstrakt/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/abstrakt/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/abstrakt/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/abstrakt/merges",
"archive_url": "https://api.github.com/repos/microsoft/abstrakt/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/abstrakt/downloads",
"issues_url": "https://api.github.com/repos/microsoft/abstrakt/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/abstrakt/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/abstrakt/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/abstrakt/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/abstrakt/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/abstrakt/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/abstrakt/deployments",
"created_at": "2019-09-02T05:20:12Z",
"updated_at": "2021-06-15T14:46:50Z",
"pushed_at": "2021-01-21T02:30:49Z",
"git_url": "git://github.com/microsoft/abstrakt.git",
"ssh_url": "git@github.com:microsoft/abstrakt.git",
"clone_url": "https://github.com/microsoft/abstrakt.git",
"svn_url": "https://github.com/microsoft/abstrakt",
"homepage": null,
"size": 15172,
"stargazers_count": 3,
"watchers_count": 3,
"language": "Go",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 5,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 5,
"watchers": 3,
"default_branch": "master"
},
{
"id": 155906961,
"node_id": "MDEwOlJlcG9zaXRvcnkxNTU5MDY5NjE=",
"name": "academic-knowledge-exploration-services-utilities",
"full_name": "microsoft/academic-knowledge-exploration-services-utilities",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/academic-knowledge-exploration-services-utilities",
"description": "Utility tools and scripts for interacting with Microsoft Academic Knowledge Exploration Service (MAKES)",
"fork": false,
"url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities",
"forks_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/forks",
"keys_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/teams",
"hooks_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/events",
"assignees_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/tags",
"blobs_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/subscription",
"commits_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/merges",
"archive_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/downloads",
"issues_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/academic-knowledge-exploration-services-utilities/deployments",
"created_at": "2018-11-02T18:32:12Z",
"updated_at": "2021-06-15T14:47:14Z",
"pushed_at": "2018-11-02T20:46:38Z",
"git_url": "git://github.com/microsoft/academic-knowledge-exploration-services-utilities.git",
"ssh_url": "git@github.com:microsoft/academic-knowledge-exploration-services-utilities.git",
"clone_url": "https://github.com/microsoft/academic-knowledge-exploration-services-utilities.git",
"svn_url": "https://github.com/microsoft/academic-knowledge-exploration-services-utilities",
"homepage": null,
"size": 11,
"stargazers_count": 7,
"watchers_count": 7,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 7,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 7,
"open_issues": 0,
"watchers": 7,
"default_branch": "master"
},
{
"id": 61397447,
"node_id": "MDEwOlJlcG9zaXRvcnk2MTM5NzQ0Nw==",
"name": "AcademicContent",
"full_name": "microsoft/AcademicContent",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AcademicContent",
"description": "Free tech resources for faculty, students, researchers, life-long learners, and academic community builders for use in tech based courses, workshops, and hackathons.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AcademicContent",
"forks_url": "https://api.github.com/repos/microsoft/AcademicContent/forks",
"keys_url": "https://api.github.com/repos/microsoft/AcademicContent/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AcademicContent/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AcademicContent/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AcademicContent/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AcademicContent/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AcademicContent/events",
"assignees_url": "https://api.github.com/repos/microsoft/AcademicContent/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AcademicContent/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AcademicContent/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AcademicContent/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AcademicContent/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AcademicContent/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AcademicContent/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AcademicContent/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AcademicContent/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AcademicContent/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AcademicContent/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AcademicContent/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AcademicContent/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AcademicContent/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AcademicContent/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AcademicContent/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AcademicContent/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AcademicContent/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AcademicContent/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AcademicContent/merges",
"archive_url": "https://api.github.com/repos/microsoft/AcademicContent/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AcademicContent/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AcademicContent/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AcademicContent/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AcademicContent/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AcademicContent/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AcademicContent/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AcademicContent/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AcademicContent/deployments",
"created_at": "2016-06-17T19:28:18Z",
"updated_at": "2021-08-20T01:59:29Z",
"pushed_at": "2021-07-08T18:04:24Z",
"git_url": "git://github.com/microsoft/AcademicContent.git",
"ssh_url": "git@github.com:microsoft/AcademicContent.git",
"clone_url": "https://github.com/microsoft/AcademicContent.git",
"svn_url": "https://github.com/microsoft/AcademicContent",
"homepage": "https://aka.ms/AcademicContent",
"size": 1213243,
"stargazers_count": 2160,
"watchers_count": 2160,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 932,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 11,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 932,
"open_issues": 11,
"watchers": 2160,
"default_branch": "main"
},
{
"id": 307846249,
"node_id": "MDEwOlJlcG9zaXRvcnkzMDc4NDYyNDk=",
"name": "acc-vm-engine",
"full_name": "microsoft/acc-vm-engine",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/acc-vm-engine",
"description": "ACC VM template generator",
"fork": false,
"url": "https://api.github.com/repos/microsoft/acc-vm-engine",
"forks_url": "https://api.github.com/repos/microsoft/acc-vm-engine/forks",
"keys_url": "https://api.github.com/repos/microsoft/acc-vm-engine/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/acc-vm-engine/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/acc-vm-engine/teams",
"hooks_url": "https://api.github.com/repos/microsoft/acc-vm-engine/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/acc-vm-engine/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/acc-vm-engine/events",
"assignees_url": "https://api.github.com/repos/microsoft/acc-vm-engine/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/acc-vm-engine/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/acc-vm-engine/tags",
"blobs_url": "https://api.github.com/repos/microsoft/acc-vm-engine/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/acc-vm-engine/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/acc-vm-engine/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/acc-vm-engine/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/acc-vm-engine/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/acc-vm-engine/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/acc-vm-engine/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/acc-vm-engine/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/acc-vm-engine/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/acc-vm-engine/subscription",
"commits_url": "https://api.github.com/repos/microsoft/acc-vm-engine/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/acc-vm-engine/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/acc-vm-engine/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/acc-vm-engine/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/acc-vm-engine/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/acc-vm-engine/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/acc-vm-engine/merges",
"archive_url": "https://api.github.com/repos/microsoft/acc-vm-engine/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/acc-vm-engine/downloads",
"issues_url": "https://api.github.com/repos/microsoft/acc-vm-engine/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/acc-vm-engine/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/acc-vm-engine/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/acc-vm-engine/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/acc-vm-engine/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/acc-vm-engine/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/acc-vm-engine/deployments",
"created_at": "2020-10-27T22:45:26Z",
"updated_at": "2021-06-15T14:48:02Z",
"pushed_at": "2021-07-09T17:36:40Z",
"git_url": "git://github.com/microsoft/acc-vm-engine.git",
"ssh_url": "git@github.com:microsoft/acc-vm-engine.git",
"clone_url": "https://github.com/microsoft/acc-vm-engine.git",
"svn_url": "https://github.com/microsoft/acc-vm-engine",
"homepage": null,
"size": 116,
"stargazers_count": 3,
"watchers_count": 3,
"language": "Go",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 2,
"license": null,
"forks": 8,
"open_issues": 2,
"watchers": 3,
"default_branch": "main"
},
{
"id": 143079769,
"node_id": "MDEwOlJlcG9zaXRvcnkxNDMwNzk3Njk=",
"name": "accbpg",
"full_name": "microsoft/accbpg",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accbpg",
"description": "Accelerated Bregman Proximal Gradient Methods",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accbpg",
"forks_url": "https://api.github.com/repos/microsoft/accbpg/forks",
"keys_url": "https://api.github.com/repos/microsoft/accbpg/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accbpg/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accbpg/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accbpg/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accbpg/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accbpg/events",
"assignees_url": "https://api.github.com/repos/microsoft/accbpg/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accbpg/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accbpg/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accbpg/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accbpg/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accbpg/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accbpg/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accbpg/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accbpg/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accbpg/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accbpg/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accbpg/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accbpg/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accbpg/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accbpg/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accbpg/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accbpg/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accbpg/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accbpg/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accbpg/merges",
"archive_url": "https://api.github.com/repos/microsoft/accbpg/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accbpg/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accbpg/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accbpg/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accbpg/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accbpg/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accbpg/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accbpg/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accbpg/deployments",
"created_at": "2018-07-31T23:23:10Z",
"updated_at": "2021-07-07T12:07:12Z",
"pushed_at": "2020-04-23T19:13:17Z",
"git_url": "git://github.com/microsoft/accbpg.git",
"ssh_url": "git@github.com:microsoft/accbpg.git",
"clone_url": "https://github.com/microsoft/accbpg.git",
"svn_url": "https://github.com/microsoft/accbpg",
"homepage": null,
"size": 2553,
"stargazers_count": 15,
"watchers_count": 15,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 0,
"watchers": 15,
"default_branch": "master"
},
{
"id": 32419990,
"node_id": "MDEwOlJlcG9zaXRvcnkzMjQxOTk5MA==",
"name": "AccCheckerExtensionForVS",
"full_name": "microsoft/AccCheckerExtensionForVS",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AccCheckerExtensionForVS",
"description": "Detect and resolve common accessibility issues before you ship your code with a free Visual Studio extension.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS",
"forks_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/forks",
"keys_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/events",
"assignees_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/merges",
"archive_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AccCheckerExtensionForVS/deployments",
"created_at": "2015-03-17T20:57:51Z",
"updated_at": "2021-06-15T14:48:50Z",
"pushed_at": "2015-05-26T20:13:19Z",
"git_url": "git://github.com/microsoft/AccCheckerExtensionForVS.git",
"ssh_url": "git@github.com:microsoft/AccCheckerExtensionForVS.git",
"clone_url": "https://github.com/microsoft/AccCheckerExtensionForVS.git",
"svn_url": "https://github.com/microsoft/AccCheckerExtensionForVS",
"homepage": null,
"size": 3074,
"stargazers_count": 15,
"watchers_count": 15,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 13,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 13,
"open_issues": 1,
"watchers": 15,
"default_branch": "master"
},
{
"id": 387382578,
"node_id": "MDEwOlJlcG9zaXRvcnkzODczODI1Nzg=",
"name": "AcceleratedML",
"full_name": "microsoft/AcceleratedML",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AcceleratedML",
"description": "With AcceleratedML Framework the time it takes to get production-ready ML models with great ease and efficiency highly accelerates. ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AcceleratedML",
"forks_url": "https://api.github.com/repos/microsoft/AcceleratedML/forks",
"keys_url": "https://api.github.com/repos/microsoft/AcceleratedML/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AcceleratedML/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AcceleratedML/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AcceleratedML/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AcceleratedML/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AcceleratedML/events",
"assignees_url": "https://api.github.com/repos/microsoft/AcceleratedML/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AcceleratedML/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AcceleratedML/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AcceleratedML/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AcceleratedML/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AcceleratedML/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AcceleratedML/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AcceleratedML/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AcceleratedML/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AcceleratedML/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AcceleratedML/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AcceleratedML/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AcceleratedML/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AcceleratedML/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AcceleratedML/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AcceleratedML/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AcceleratedML/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AcceleratedML/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AcceleratedML/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AcceleratedML/merges",
"archive_url": "https://api.github.com/repos/microsoft/AcceleratedML/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AcceleratedML/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AcceleratedML/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AcceleratedML/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AcceleratedML/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AcceleratedML/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AcceleratedML/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AcceleratedML/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AcceleratedML/deployments",
"created_at": "2021-07-19T07:50:30Z",
"updated_at": "2021-08-16T12:58:58Z",
"pushed_at": "2021-08-16T12:58:55Z",
"git_url": "git://github.com/microsoft/AcceleratedML.git",
"ssh_url": "git@github.com:microsoft/AcceleratedML.git",
"clone_url": "https://github.com/microsoft/AcceleratedML.git",
"svn_url": "https://github.com/microsoft/AcceleratedML",
"homepage": "",
"size": 77505,
"stargazers_count": 5,
"watchers_count": 5,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 0,
"watchers": 5,
"default_branch": "main"
},
{
"id": 275836864,
"node_id": "MDEwOlJlcG9zaXRvcnkyNzU4MzY4NjQ=",
"name": "Accelerator-AzureML_CognitiveSearch",
"full_name": "microsoft/Accelerator-AzureML_CognitiveSearch",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/Accelerator-AzureML_CognitiveSearch",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch",
"forks_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/forks",
"keys_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/teams",
"hooks_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/events",
"assignees_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/tags",
"blobs_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/subscription",
"commits_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/merges",
"archive_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/downloads",
"issues_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/Accelerator-AzureML_CognitiveSearch/deployments",
"created_at": "2020-06-29T14:20:15Z",
"updated_at": "2021-08-18T20:41:27Z",
"pushed_at": "2020-10-23T17:26:01Z",
"git_url": "git://github.com/microsoft/Accelerator-AzureML_CognitiveSearch.git",
"ssh_url": "git@github.com:microsoft/Accelerator-AzureML_CognitiveSearch.git",
"clone_url": "https://github.com/microsoft/Accelerator-AzureML_CognitiveSearch.git",
"svn_url": "https://github.com/microsoft/Accelerator-AzureML_CognitiveSearch",
"homepage": null,
"size": 76804,
"stargazers_count": 19,
"watchers_count": 19,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 11,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 4,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 11,
"open_issues": 4,
"watchers": 19,
"default_branch": "master"
},
{
"id": 81911108,
"node_id": "MDEwOlJlcG9zaXRvcnk4MTkxMTEwOA==",
"name": "acceleratoRs",
"full_name": "microsoft/acceleratoRs",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/acceleratoRs",
"description": "Data science and AI solution accelerator suite that provides templates for prototyping, reporting, and presenting data science analytics of specific domains",
"fork": false,
"url": "https://api.github.com/repos/microsoft/acceleratoRs",
"forks_url": "https://api.github.com/repos/microsoft/acceleratoRs/forks",
"keys_url": "https://api.github.com/repos/microsoft/acceleratoRs/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/acceleratoRs/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/acceleratoRs/teams",
"hooks_url": "https://api.github.com/repos/microsoft/acceleratoRs/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/acceleratoRs/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/acceleratoRs/events",
"assignees_url": "https://api.github.com/repos/microsoft/acceleratoRs/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/acceleratoRs/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/acceleratoRs/tags",
"blobs_url": "https://api.github.com/repos/microsoft/acceleratoRs/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/acceleratoRs/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/acceleratoRs/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/acceleratoRs/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/acceleratoRs/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/acceleratoRs/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/acceleratoRs/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/acceleratoRs/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/acceleratoRs/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/acceleratoRs/subscription",
"commits_url": "https://api.github.com/repos/microsoft/acceleratoRs/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/acceleratoRs/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/acceleratoRs/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/acceleratoRs/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/acceleratoRs/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/acceleratoRs/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/acceleratoRs/merges",
"archive_url": "https://api.github.com/repos/microsoft/acceleratoRs/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/acceleratoRs/downloads",
"issues_url": "https://api.github.com/repos/microsoft/acceleratoRs/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/acceleratoRs/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/acceleratoRs/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/acceleratoRs/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/acceleratoRs/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/acceleratoRs/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/acceleratoRs/deployments",
"created_at": "2017-02-14T06:04:55Z",
"updated_at": "2021-06-15T14:49:38Z",
"pushed_at": "2019-07-12T16:18:11Z",
"git_url": "git://github.com/microsoft/acceleratoRs.git",
"ssh_url": "git@github.com:microsoft/acceleratoRs.git",
"clone_url": "https://github.com/microsoft/acceleratoRs.git",
"svn_url": "https://github.com/microsoft/acceleratoRs",
"homepage": "https://github.com/Microsoft/acceleratoRs",
"size": 65801,
"stargazers_count": 137,
"watchers_count": 137,
"language": "HTML",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 141,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 141,
"open_issues": 0,
"watchers": 137,
"default_branch": "master"
},
{
"id": 270963908,
"node_id": "MDEwOlJlcG9zaXRvcnkyNzA5NjM5MDg=",
"name": "access-reviews-samples",
"full_name": "microsoft/access-reviews-samples",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/access-reviews-samples",
"description": "This repo contains sample code that demonstrates programmatic access to Azure AD Access Reviews. Sample code includes reading and managing Access Reviews, as well as working on decisions and results of Access Reviews.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/access-reviews-samples",
"forks_url": "https://api.github.com/repos/microsoft/access-reviews-samples/forks",
"keys_url": "https://api.github.com/repos/microsoft/access-reviews-samples/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/access-reviews-samples/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/access-reviews-samples/teams",
"hooks_url": "https://api.github.com/repos/microsoft/access-reviews-samples/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/access-reviews-samples/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/access-reviews-samples/events",
"assignees_url": "https://api.github.com/repos/microsoft/access-reviews-samples/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/access-reviews-samples/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/access-reviews-samples/tags",
"blobs_url": "https://api.github.com/repos/microsoft/access-reviews-samples/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/access-reviews-samples/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/access-reviews-samples/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/access-reviews-samples/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/access-reviews-samples/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/access-reviews-samples/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/access-reviews-samples/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/access-reviews-samples/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/access-reviews-samples/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/access-reviews-samples/subscription",
"commits_url": "https://api.github.com/repos/microsoft/access-reviews-samples/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/access-reviews-samples/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/access-reviews-samples/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/access-reviews-samples/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/access-reviews-samples/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/access-reviews-samples/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/access-reviews-samples/merges",
"archive_url": "https://api.github.com/repos/microsoft/access-reviews-samples/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/access-reviews-samples/downloads",
"issues_url": "https://api.github.com/repos/microsoft/access-reviews-samples/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/access-reviews-samples/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/access-reviews-samples/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/access-reviews-samples/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/access-reviews-samples/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/access-reviews-samples/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/access-reviews-samples/deployments",
"created_at": "2020-06-09T09:48:00Z",
"updated_at": "2021-08-22T19:10:23Z",
"pushed_at": "2021-07-08T12:30:45Z",
"git_url": "git://github.com/microsoft/access-reviews-samples.git",
"ssh_url": "git@github.com:microsoft/access-reviews-samples.git",
"clone_url": "https://github.com/microsoft/access-reviews-samples.git",
"svn_url": "https://github.com/microsoft/access-reviews-samples",
"homepage": null,
"size": 736,
"stargazers_count": 10,
"watchers_count": 10,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 4,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 4,
"open_issues": 1,
"watchers": 10,
"default_branch": "master"
},
{
"id": 238191527,
"node_id": "MDEwOlJlcG9zaXRvcnkyMzgxOTE1Mjc=",
"name": "accessibility-announcer",
"full_name": "microsoft/accessibility-announcer",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accessibility-announcer",
"description": "A tool to provide the screen reader announcements on the web.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accessibility-announcer",
"forks_url": "https://api.github.com/repos/microsoft/accessibility-announcer/forks",
"keys_url": "https://api.github.com/repos/microsoft/accessibility-announcer/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accessibility-announcer/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accessibility-announcer/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accessibility-announcer/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accessibility-announcer/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accessibility-announcer/events",
"assignees_url": "https://api.github.com/repos/microsoft/accessibility-announcer/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accessibility-announcer/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accessibility-announcer/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accessibility-announcer/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accessibility-announcer/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accessibility-announcer/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accessibility-announcer/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accessibility-announcer/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accessibility-announcer/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accessibility-announcer/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accessibility-announcer/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accessibility-announcer/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accessibility-announcer/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accessibility-announcer/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accessibility-announcer/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accessibility-announcer/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accessibility-announcer/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accessibility-announcer/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accessibility-announcer/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accessibility-announcer/merges",
"archive_url": "https://api.github.com/repos/microsoft/accessibility-announcer/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accessibility-announcer/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accessibility-announcer/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accessibility-announcer/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accessibility-announcer/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accessibility-announcer/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accessibility-announcer/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accessibility-announcer/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accessibility-announcer/deployments",
"created_at": "2020-02-04T11:37:30Z",
"updated_at": "2021-06-15T14:50:26Z",
"pushed_at": "2021-02-12T12:42:32Z",
"git_url": "git://github.com/microsoft/accessibility-announcer.git",
"ssh_url": "git@github.com:microsoft/accessibility-announcer.git",
"clone_url": "https://github.com/microsoft/accessibility-announcer.git",
"svn_url": "https://github.com/microsoft/accessibility-announcer",
"homepage": null,
"size": 17,
"stargazers_count": 1,
"watchers_count": 1,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 1,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 1,
"open_issues": 0,
"watchers": 1,
"default_branch": "master"
},
{
"id": 238042767,
"node_id": "MDEwOlJlcG9zaXRvcnkyMzgwNDI3Njc=",
"name": "accessibility-insights-action",
"full_name": "microsoft/accessibility-insights-action",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accessibility-insights-action",
"description": "Github Action to scan for accessibility issues in github pages",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accessibility-insights-action",
"forks_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/forks",
"keys_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/events",
"assignees_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/merges",
"archive_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accessibility-insights-action/deployments",
"created_at": "2020-02-03T19:20:37Z",
"updated_at": "2021-08-19T21:17:49Z",
"pushed_at": "2021-08-20T18:02:37Z",
"git_url": "git://github.com/microsoft/accessibility-insights-action.git",
"ssh_url": "git@github.com:microsoft/accessibility-insights-action.git",
"clone_url": "https://github.com/microsoft/accessibility-insights-action.git",
"svn_url": "https://github.com/microsoft/accessibility-insights-action",
"homepage": null,
"size": 11853,
"stargazers_count": 37,
"watchers_count": 37,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 17,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 9,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 17,
"open_issues": 9,
"watchers": 37,
"default_branch": "main"
},
{
"id": 243875832,
"node_id": "MDEwOlJlcG9zaXRvcnkyNDM4NzU4MzI=",
"name": "accessibility-insights-for-android-service",
"full_name": "microsoft/accessibility-insights-for-android-service",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accessibility-insights-for-android-service",
"description": "Accessibility Insights for Android service",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service",
"forks_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/forks",
"keys_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/events",
"assignees_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/merges",
"archive_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accessibility-insights-for-android-service/deployments",
"created_at": "2020-02-29T00:00:38Z",
"updated_at": "2021-08-19T07:35:18Z",
"pushed_at": "2021-08-23T06:02:20Z",
"git_url": "git://github.com/microsoft/accessibility-insights-for-android-service.git",
"ssh_url": "git@github.com:microsoft/accessibility-insights-for-android-service.git",
"clone_url": "https://github.com/microsoft/accessibility-insights-for-android-service.git",
"svn_url": "https://github.com/microsoft/accessibility-insights-for-android-service",
"homepage": null,
"size": 413,
"stargazers_count": 27,
"watchers_count": 27,
"language": "HTML",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 31,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 4,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 31,
"open_issues": 4,
"watchers": 27,
"default_branch": "main"
},
{
"id": 160751350,
"node_id": "MDEwOlJlcG9zaXRvcnkxNjA3NTEzNTA=",
"name": "accessibility-insights-service",
"full_name": "microsoft/accessibility-insights-service",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accessibility-insights-service",
"description": "Accessibility Insights Service",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accessibility-insights-service",
"forks_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/forks",
"keys_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/events",
"assignees_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/merges",
"archive_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accessibility-insights-service/deployments",
"created_at": "2018-12-07T00:55:32Z",
"updated_at": "2021-08-21T18:00:18Z",
"pushed_at": "2021-08-21T18:18:02Z",
"git_url": "git://github.com/microsoft/accessibility-insights-service.git",
"ssh_url": "git@github.com:microsoft/accessibility-insights-service.git",
"clone_url": "https://github.com/microsoft/accessibility-insights-service.git",
"svn_url": "https://github.com/microsoft/accessibility-insights-service",
"homepage": null,
"size": 15425,
"stargazers_count": 41,
"watchers_count": 41,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 31,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 7,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 31,
"open_issues": 7,
"watchers": 41,
"default_branch": "main"
},
{
"id": 160750261,
"node_id": "MDEwOlJlcG9zaXRvcnkxNjA3NTAyNjE=",
"name": "accessibility-insights-web",
"full_name": "microsoft/accessibility-insights-web",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accessibility-insights-web",
"description": "Accessibility Insights for Web",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accessibility-insights-web",
"forks_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/forks",
"keys_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/events",
"assignees_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/merges",
"archive_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accessibility-insights-web/deployments",
"created_at": "2018-12-07T00:40:02Z",
"updated_at": "2021-08-19T21:17:38Z",
"pushed_at": "2021-08-19T21:29:39Z",
"git_url": "git://github.com/microsoft/accessibility-insights-web.git",
"ssh_url": "git@github.com:microsoft/accessibility-insights-web.git",
"clone_url": "https://github.com/microsoft/accessibility-insights-web.git",
"svn_url": "https://github.com/microsoft/accessibility-insights-web",
"homepage": "https://accessibilityinsights.io",
"size": 52512,
"stargazers_count": 583,
"watchers_count": 583,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 114,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 70,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 114,
"open_issues": 70,
"watchers": 583,
"default_branch": "main"
},
{
"id": 160750843,
"node_id": "MDEwOlJlcG9zaXRvcnkxNjA3NTA4NDM=",
"name": "accessibility-insights-windows",
"full_name": "microsoft/accessibility-insights-windows",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/accessibility-insights-windows",
"description": "Accessibility Insights for Windows",
"fork": false,
"url": "https://api.github.com/repos/microsoft/accessibility-insights-windows",
"forks_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/forks",
"keys_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/teams",
"hooks_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/events",
"assignees_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/tags",
"blobs_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/subscription",
"commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/merges",
"archive_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/downloads",
"issues_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/accessibility-insights-windows/deployments",
"created_at": "2018-12-07T00:48:10Z",
"updated_at": "2021-08-20T15:26:55Z",
"pushed_at": "2021-08-20T08:44:11Z",
"git_url": "git://github.com/microsoft/accessibility-insights-windows.git",
"ssh_url": "git@github.com:microsoft/accessibility-insights-windows.git",
"clone_url": "https://github.com/microsoft/accessibility-insights-windows.git",
"svn_url": "https://github.com/microsoft/accessibility-insights-windows",
"homepage": "https://accessibilityinsights.io",
"size": 6383,
"stargazers_count": 232,
"watchers_count": 232,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 56,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 38,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 56,
"open_issues": 38,
"watchers": 232,
"default_branch": "main"
},
{
"id": 205215545,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDUyMTU1NDU=",
"name": "AccessorFramework",
"full_name": "microsoft/AccessorFramework",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AccessorFramework",
"description": "A C++ SDK for building cyber-physical applications using the Accessor Model",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AccessorFramework",
"forks_url": "https://api.github.com/repos/microsoft/AccessorFramework/forks",
"keys_url": "https://api.github.com/repos/microsoft/AccessorFramework/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AccessorFramework/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AccessorFramework/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AccessorFramework/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AccessorFramework/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AccessorFramework/events",
"assignees_url": "https://api.github.com/repos/microsoft/AccessorFramework/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AccessorFramework/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AccessorFramework/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AccessorFramework/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AccessorFramework/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AccessorFramework/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AccessorFramework/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AccessorFramework/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AccessorFramework/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AccessorFramework/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AccessorFramework/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AccessorFramework/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AccessorFramework/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AccessorFramework/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AccessorFramework/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AccessorFramework/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AccessorFramework/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AccessorFramework/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AccessorFramework/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AccessorFramework/merges",
"archive_url": "https://api.github.com/repos/microsoft/AccessorFramework/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AccessorFramework/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AccessorFramework/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AccessorFramework/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AccessorFramework/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AccessorFramework/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AccessorFramework/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AccessorFramework/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AccessorFramework/deployments",
"created_at": "2019-08-29T17:24:38Z",
"updated_at": "2021-05-27T06:16:36Z",
"pushed_at": "2020-02-25T22:22:00Z",
"git_url": "git://github.com/microsoft/AccessorFramework.git",
"ssh_url": "git@github.com:microsoft/AccessorFramework.git",
"clone_url": "https://github.com/microsoft/AccessorFramework.git",
"svn_url": "https://github.com/microsoft/AccessorFramework",
"homepage": null,
"size": 70,
"stargazers_count": 12,
"watchers_count": 12,
"language": "C++",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 6,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 6,
"open_issues": 2,
"watchers": 12,
"default_branch": "master"
},
{
"id": 225860378,
"node_id": "MDEwOlJlcG9zaXRvcnkyMjU4NjAzNzg=",
"name": "AccountGuard",
"full_name": "microsoft/AccountGuard",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AccountGuard",
"description": "Security ARM Templates for AccountGuard Enrollees ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AccountGuard",
"forks_url": "https://api.github.com/repos/microsoft/AccountGuard/forks",
"keys_url": "https://api.github.com/repos/microsoft/AccountGuard/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AccountGuard/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AccountGuard/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AccountGuard/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AccountGuard/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AccountGuard/events",
"assignees_url": "https://api.github.com/repos/microsoft/AccountGuard/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AccountGuard/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AccountGuard/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AccountGuard/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AccountGuard/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AccountGuard/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AccountGuard/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AccountGuard/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AccountGuard/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AccountGuard/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AccountGuard/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AccountGuard/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AccountGuard/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AccountGuard/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AccountGuard/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AccountGuard/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AccountGuard/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AccountGuard/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AccountGuard/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AccountGuard/merges",
"archive_url": "https://api.github.com/repos/microsoft/AccountGuard/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AccountGuard/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AccountGuard/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AccountGuard/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AccountGuard/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AccountGuard/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AccountGuard/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AccountGuard/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AccountGuard/deployments",
"created_at": "2019-12-04T12:19:12Z",
"updated_at": "2020-09-09T02:33:01Z",
"pushed_at": "2020-02-10T01:27:49Z",
"git_url": "git://github.com/microsoft/AccountGuard.git",
"ssh_url": "git@github.com:microsoft/AccountGuard.git",
"clone_url": "https://github.com/microsoft/AccountGuard.git",
"svn_url": "https://github.com/microsoft/AccountGuard",
"homepage": null,
"size": 114,
"stargazers_count": 2,
"watchers_count": 2,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 4,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 4,
"open_issues": 0,
"watchers": 2,
"default_branch": "master"
},
{
"id": 50415500,
"node_id": "MDEwOlJlcG9zaXRvcnk1MDQxNTUwMA==",
"name": "ace",
"full_name": "microsoft/ace",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ace",
"description": "Build Cordova apps with true native UI",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ace",
"forks_url": "https://api.github.com/repos/microsoft/ace/forks",
"keys_url": "https://api.github.com/repos/microsoft/ace/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ace/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ace/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ace/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ace/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ace/events",
"assignees_url": "https://api.github.com/repos/microsoft/ace/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ace/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ace/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ace/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ace/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ace/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ace/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ace/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ace/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ace/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ace/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ace/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ace/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ace/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ace/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ace/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ace/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ace/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ace/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ace/merges",
"archive_url": "https://api.github.com/repos/microsoft/ace/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ace/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ace/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ace/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ace/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ace/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ace/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ace/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ace/deployments",
"created_at": "2016-01-26T08:41:38Z",
"updated_at": "2021-08-06T22:59:40Z",
"pushed_at": "2016-11-17T04:52:05Z",
"git_url": "git://github.com/microsoft/ace.git",
"ssh_url": "git@github.com:microsoft/ace.git",
"clone_url": "https://github.com/microsoft/ace.git",
"svn_url": "https://github.com/microsoft/ace",
"homepage": "http://microsoft.github.io/ace",
"size": 3364,
"stargazers_count": 853,
"watchers_count": 853,
"language": "Objective-C++",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 166,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 25,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 166,
"open_issues": 25,
"watchers": 853,
"default_branch": "master"
},
{
"id": 298142651,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTgxNDI2NTE=",
"name": "acoustic-bird-detection",
"full_name": "microsoft/acoustic-bird-detection",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/acoustic-bird-detection",
"description": "Machine learning tools for acoustic bird detection",
"fork": false,
"url": "https://api.github.com/repos/microsoft/acoustic-bird-detection",
"forks_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/forks",
"keys_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/teams",
"hooks_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/events",
"assignees_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/tags",
"blobs_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/subscription",
"commits_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/merges",
"archive_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/downloads",
"issues_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/acoustic-bird-detection/deployments",
"created_at": "2020-09-24T01:57:25Z",
"updated_at": "2021-08-09T02:13:31Z",
"pushed_at": "2020-10-15T15:16:15Z",
"git_url": "git://github.com/microsoft/acoustic-bird-detection.git",
"ssh_url": "git@github.com:microsoft/acoustic-bird-detection.git",
"clone_url": "https://github.com/microsoft/acoustic-bird-detection.git",
"svn_url": "https://github.com/microsoft/acoustic-bird-detection",
"homepage": null,
"size": 1909,
"stargazers_count": 17,
"watchers_count": 17,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 9,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 9,
"open_issues": 0,
"watchers": 17,
"default_branch": "main"
},
{
"id": 393144531,
"node_id": "MDEwOlJlcG9zaXRvcnkzOTMxNDQ1MzE=",
"name": "Acoustic-Perception-for-Virtual-AI-Agents",
"full_name": "microsoft/Acoustic-Perception-for-Virtual-AI-Agents",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/Acoustic-Perception-for-Virtual-AI-Agents",
"description": "This repository contains source code demonstrating the techniques discussed in the associated paper, Efficient Acoustic Perception for Virtual AI Agents",
"fork": false,
"url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents",
"forks_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/forks",
"keys_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/teams",
"hooks_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/events",
"assignees_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/tags",
"blobs_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/subscription",
"commits_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/merges",
"archive_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/downloads",
"issues_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/Acoustic-Perception-for-Virtual-AI-Agents/deployments",
"created_at": "2021-08-05T18:58:39Z",
"updated_at": "2021-08-05T21:12:12Z",
"pushed_at": "2021-08-05T21:12:10Z",
"git_url": "git://github.com/microsoft/Acoustic-Perception-for-Virtual-AI-Agents.git",
"ssh_url": "git@github.com:microsoft/Acoustic-Perception-for-Virtual-AI-Agents.git",
"clone_url": "https://github.com/microsoft/Acoustic-Perception-for-Virtual-AI-Agents.git",
"svn_url": "https://github.com/microsoft/Acoustic-Perception-for-Virtual-AI-Agents",
"homepage": null,
"size": 9,
"stargazers_count": 0,
"watchers_count": 0,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 0,
"watchers": 0,
"default_branch": "main"
},
{
"id": 236407033,
"node_id": "MDEwOlJlcG9zaXRvcnkyMzY0MDcwMzM=",
"name": "AcousticScatteringData",
"full_name": "microsoft/AcousticScatteringData",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AcousticScatteringData",
"description": "Synthetic exterior acoustic scattering data and sample parsing code.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AcousticScatteringData",
"forks_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/forks",
"keys_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/events",
"assignees_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/merges",
"archive_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AcousticScatteringData/deployments",
"created_at": "2020-01-27T02:24:04Z",
"updated_at": "2021-07-12T12:16:10Z",
"pushed_at": "2020-02-05T18:31:26Z",
"git_url": "git://github.com/microsoft/AcousticScatteringData.git",
"ssh_url": "git@github.com:microsoft/AcousticScatteringData.git",
"clone_url": "https://github.com/microsoft/AcousticScatteringData.git",
"svn_url": "https://github.com/microsoft/AcousticScatteringData",
"homepage": "",
"size": 69265,
"stargazers_count": 8,
"watchers_count": 8,
"language": "MATLAB",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 4,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": null,
"forks": 4,
"open_issues": 0,
"watchers": 8,
"default_branch": "master"
},
{
"id": 23141872,
"node_id": "MDEwOlJlcG9zaXRvcnkyMzE0MTg3Mg==",
"name": "activate-sensorcore",
"full_name": "microsoft/activate-sensorcore",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/activate-sensorcore",
"description": "Helper library for SensorCore SDK to activate Location and Motion data",
"fork": false,
"url": "https://api.github.com/repos/microsoft/activate-sensorcore",
"forks_url": "https://api.github.com/repos/microsoft/activate-sensorcore/forks",
"keys_url": "https://api.github.com/repos/microsoft/activate-sensorcore/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/activate-sensorcore/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/activate-sensorcore/teams",
"hooks_url": "https://api.github.com/repos/microsoft/activate-sensorcore/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/activate-sensorcore/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/activate-sensorcore/events",
"assignees_url": "https://api.github.com/repos/microsoft/activate-sensorcore/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/activate-sensorcore/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/activate-sensorcore/tags",
"blobs_url": "https://api.github.com/repos/microsoft/activate-sensorcore/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/activate-sensorcore/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/activate-sensorcore/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/activate-sensorcore/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/activate-sensorcore/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/activate-sensorcore/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/activate-sensorcore/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/activate-sensorcore/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/activate-sensorcore/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/activate-sensorcore/subscription",
"commits_url": "https://api.github.com/repos/microsoft/activate-sensorcore/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/activate-sensorcore/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/activate-sensorcore/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/activate-sensorcore/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/activate-sensorcore/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/activate-sensorcore/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/activate-sensorcore/merges",
"archive_url": "https://api.github.com/repos/microsoft/activate-sensorcore/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/activate-sensorcore/downloads",
"issues_url": "https://api.github.com/repos/microsoft/activate-sensorcore/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/activate-sensorcore/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/activate-sensorcore/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/activate-sensorcore/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/activate-sensorcore/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/activate-sensorcore/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/activate-sensorcore/deployments",
"created_at": "2014-08-20T08:43:06Z",
"updated_at": "2021-06-12T14:53:53Z",
"pushed_at": "2014-11-27T12:10:44Z",
"git_url": "git://github.com/microsoft/activate-sensorcore.git",
"ssh_url": "git@github.com:microsoft/activate-sensorcore.git",
"clone_url": "https://github.com/microsoft/activate-sensorcore.git",
"svn_url": "https://github.com/microsoft/activate-sensorcore",
"homepage": null,
"size": 308,
"stargazers_count": 15,
"watchers_count": 15,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 15,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 0,
"license": null,
"forks": 15,
"open_issues": 0,
"watchers": 15,
"default_branch": "master"
},
{
"id": 125377789,
"node_id": "MDEwOlJlcG9zaXRvcnkxMjUzNzc3ODk=",
"name": "ActiveDirectoryDSC.Reverse",
"full_name": "microsoft/ActiveDirectoryDSC.Reverse",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ActiveDirectoryDSC.Reverse",
"description": "ReverseDSC Orchestrator for ActiveDirectory",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse",
"forks_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/forks",
"keys_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/events",
"assignees_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/merges",
"archive_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ActiveDirectoryDSC.Reverse/deployments",
"created_at": "2018-03-15T14:15:17Z",
"updated_at": "2021-05-10T12:32:25Z",
"pushed_at": "2019-01-09T18:30:45Z",
"git_url": "git://github.com/microsoft/ActiveDirectoryDSC.Reverse.git",
"ssh_url": "git@github.com:microsoft/ActiveDirectoryDSC.Reverse.git",
"clone_url": "https://github.com/microsoft/ActiveDirectoryDSC.Reverse.git",
"svn_url": "https://github.com/microsoft/ActiveDirectoryDSC.Reverse",
"homepage": null,
"size": 32,
"stargazers_count": 10,
"watchers_count": 10,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 2,
"watchers": 10,
"default_branch": "master"
},
{
"id": 21122049,
"node_id": "MDEwOlJlcG9zaXRvcnkyMTEyMjA0OQ==",
"name": "activities",
"full_name": "microsoft/activities",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/activities",
"description": "Lumia SensorCore SDK sample for Activity Monitor API.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/activities",
"forks_url": "https://api.github.com/repos/microsoft/activities/forks",
"keys_url": "https://api.github.com/repos/microsoft/activities/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/activities/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/activities/teams",
"hooks_url": "https://api.github.com/repos/microsoft/activities/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/activities/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/activities/events",
"assignees_url": "https://api.github.com/repos/microsoft/activities/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/activities/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/activities/tags",
"blobs_url": "https://api.github.com/repos/microsoft/activities/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/activities/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/activities/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/activities/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/activities/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/activities/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/activities/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/activities/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/activities/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/activities/subscription",
"commits_url": "https://api.github.com/repos/microsoft/activities/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/activities/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/activities/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/activities/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/activities/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/activities/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/activities/merges",
"archive_url": "https://api.github.com/repos/microsoft/activities/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/activities/downloads",
"issues_url": "https://api.github.com/repos/microsoft/activities/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/activities/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/activities/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/activities/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/activities/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/activities/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/activities/deployments",
"created_at": "2014-06-23T10:18:38Z",
"updated_at": "2021-04-20T15:55:11Z",
"pushed_at": "2018-10-24T16:19:51Z",
"git_url": "git://github.com/microsoft/activities.git",
"ssh_url": "git@github.com:microsoft/activities.git",
"clone_url": "https://github.com/microsoft/activities.git",
"svn_url": "https://github.com/microsoft/activities",
"homepage": "",
"size": 986,
"stargazers_count": 20,
"watchers_count": 20,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 19,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 1,
"license": null,
"forks": 19,
"open_issues": 1,
"watchers": 20,
"default_branch": "master"
},
{
"id": 124488994,
"node_id": "MDEwOlJlcG9zaXRvcnkxMjQ0ODg5OTQ=",
"name": "activity-log-export-automation",
"full_name": "microsoft/activity-log-export-automation",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/activity-log-export-automation",
"description": "Connect Splunk to Azure Activity Log via PowerShell automation",
"fork": false,
"url": "https://api.github.com/repos/microsoft/activity-log-export-automation",
"forks_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/forks",
"keys_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/teams",
"hooks_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/events",
"assignees_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/tags",
"blobs_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/subscription",
"commits_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/merges",
"archive_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/downloads",
"issues_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/activity-log-export-automation/deployments",
"created_at": "2018-03-09T04:47:36Z",
"updated_at": "2021-04-20T16:13:58Z",
"pushed_at": "2018-10-13T23:39:24Z",
"git_url": "git://github.com/microsoft/activity-log-export-automation.git",
"ssh_url": "git@github.com:microsoft/activity-log-export-automation.git",
"clone_url": "https://github.com/microsoft/activity-log-export-automation.git",
"svn_url": "https://github.com/microsoft/activity-log-export-automation",
"homepage": null,
"size": 44,
"stargazers_count": 12,
"watchers_count": 12,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 0,
"watchers": 12,
"default_branch": "master"
},
{
"id": 96660739,
"node_id": "MDEwOlJlcG9zaXRvcnk5NjY2MDczOQ==",
"name": "Adaptable",
"full_name": "microsoft/Adaptable",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/Adaptable",
"description": "A tightly optimized representation of ordered, long-living, often-modified, predicate-filtered lists random-accessible by value and index. (Java)",
"fork": false,
"url": "https://api.github.com/repos/microsoft/Adaptable",
"forks_url": "https://api.github.com/repos/microsoft/Adaptable/forks",
"keys_url": "https://api.github.com/repos/microsoft/Adaptable/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/Adaptable/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/Adaptable/teams",
"hooks_url": "https://api.github.com/repos/microsoft/Adaptable/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/Adaptable/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/Adaptable/events",
"assignees_url": "https://api.github.com/repos/microsoft/Adaptable/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/Adaptable/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/Adaptable/tags",
"blobs_url": "https://api.github.com/repos/microsoft/Adaptable/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/Adaptable/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/Adaptable/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/Adaptable/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/Adaptable/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/Adaptable/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/Adaptable/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/Adaptable/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/Adaptable/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/Adaptable/subscription",
"commits_url": "https://api.github.com/repos/microsoft/Adaptable/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/Adaptable/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/Adaptable/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/Adaptable/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/Adaptable/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/Adaptable/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/Adaptable/merges",
"archive_url": "https://api.github.com/repos/microsoft/Adaptable/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/Adaptable/downloads",
"issues_url": "https://api.github.com/repos/microsoft/Adaptable/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/Adaptable/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/Adaptable/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/Adaptable/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/Adaptable/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/Adaptable/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/Adaptable/deployments",
"created_at": "2017-07-09T04:21:42Z",
"updated_at": "2021-04-20T16:09:49Z",
"pushed_at": "2018-10-10T18:41:30Z",
"git_url": "git://github.com/microsoft/Adaptable.git",
"ssh_url": "git@github.com:microsoft/Adaptable.git",
"clone_url": "https://github.com/microsoft/Adaptable.git",
"svn_url": "https://github.com/microsoft/Adaptable",
"homepage": null,
"size": 57,
"stargazers_count": 7,
"watchers_count": 7,
"language": "Java",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 9,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 9,
"open_issues": 1,
"watchers": 7,
"default_branch": "master"
},
{
"id": 75978731,
"node_id": "MDEwOlJlcG9zaXRvcnk3NTk3ODczMQ==",
"name": "AdaptiveCards",
"full_name": "microsoft/AdaptiveCards",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AdaptiveCards",
"description": "A new way for developers to exchange card content in a common and consistent way.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AdaptiveCards",
"forks_url": "https://api.github.com/repos/microsoft/AdaptiveCards/forks",
"keys_url": "https://api.github.com/repos/microsoft/AdaptiveCards/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AdaptiveCards/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AdaptiveCards/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AdaptiveCards/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AdaptiveCards/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AdaptiveCards/events",
"assignees_url": "https://api.github.com/repos/microsoft/AdaptiveCards/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AdaptiveCards/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AdaptiveCards/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AdaptiveCards/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AdaptiveCards/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AdaptiveCards/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AdaptiveCards/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AdaptiveCards/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AdaptiveCards/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AdaptiveCards/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AdaptiveCards/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AdaptiveCards/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AdaptiveCards/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AdaptiveCards/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AdaptiveCards/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AdaptiveCards/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AdaptiveCards/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AdaptiveCards/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AdaptiveCards/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AdaptiveCards/merges",
"archive_url": "https://api.github.com/repos/microsoft/AdaptiveCards/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AdaptiveCards/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AdaptiveCards/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AdaptiveCards/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AdaptiveCards/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AdaptiveCards/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AdaptiveCards/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AdaptiveCards/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AdaptiveCards/deployments",
"created_at": "2016-12-08T22:00:33Z",
"updated_at": "2021-08-23T02:50:09Z",
"pushed_at": "2021-08-21T13:45:38Z",
"git_url": "git://github.com/microsoft/AdaptiveCards.git",
"ssh_url": "git@github.com:microsoft/AdaptiveCards.git",
"clone_url": "https://github.com/microsoft/AdaptiveCards.git",
"svn_url": "https://github.com/microsoft/AdaptiveCards",
"homepage": "https://adaptivecards.io",
"size": 342885,
"stargazers_count": 1036,
"watchers_count": 1036,
"language": "C++",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 387,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 913,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 387,
"open_issues": 913,
"watchers": 1036,
"default_branch": "main"
},
{
"id": 190425217,
"node_id": "MDEwOlJlcG9zaXRvcnkxOTA0MjUyMTc=",
"name": "adaptivecards-templates",
"full_name": "microsoft/adaptivecards-templates",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adaptivecards-templates",
"description": "A collection of Adaptive Card templates for well-known data models",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adaptivecards-templates",
"forks_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/forks",
"keys_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/events",
"assignees_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/merges",
"archive_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adaptivecards-templates/deployments",
"created_at": "2019-06-05T15:56:48Z",
"updated_at": "2021-07-27T20:36:08Z",
"pushed_at": "2021-08-11T16:45:08Z",
"git_url": "git://github.com/microsoft/adaptivecards-templates.git",
"ssh_url": "git@github.com:microsoft/adaptivecards-templates.git",
"clone_url": "https://github.com/microsoft/adaptivecards-templates.git",
"svn_url": "https://github.com/microsoft/adaptivecards-templates",
"homepage": "https://docs.microsoft.com/en-us/adaptive-cards/templating/service",
"size": 4937,
"stargazers_count": 62,
"watchers_count": 62,
"language": "JavaScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 24,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 13,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 24,
"open_issues": 13,
"watchers": 62,
"default_branch": "master"
},
{
"id": 38539834,
"node_id": "MDEwOlJlcG9zaXRvcnkzODUzOTgzNA==",
"name": "ADBench",
"full_name": "microsoft/ADBench",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ADBench",
"description": "Benchmarking various AD tools.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ADBench",
"forks_url": "https://api.github.com/repos/microsoft/ADBench/forks",
"keys_url": "https://api.github.com/repos/microsoft/ADBench/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ADBench/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ADBench/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ADBench/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ADBench/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ADBench/events",
"assignees_url": "https://api.github.com/repos/microsoft/ADBench/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ADBench/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ADBench/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ADBench/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ADBench/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ADBench/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ADBench/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ADBench/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ADBench/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ADBench/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ADBench/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ADBench/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ADBench/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ADBench/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ADBench/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ADBench/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ADBench/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ADBench/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ADBench/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ADBench/merges",
"archive_url": "https://api.github.com/repos/microsoft/ADBench/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ADBench/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ADBench/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ADBench/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ADBench/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ADBench/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ADBench/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ADBench/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ADBench/deployments",
"created_at": "2015-07-04T16:16:32Z",
"updated_at": "2021-08-09T08:46:46Z",
"pushed_at": "2021-06-28T10:35:35Z",
"git_url": "git://github.com/microsoft/ADBench.git",
"ssh_url": "git@github.com:microsoft/ADBench.git",
"clone_url": "https://github.com/microsoft/ADBench.git",
"svn_url": "https://github.com/microsoft/ADBench",
"homepage": "",
"size": 146179,
"stargazers_count": 70,
"watchers_count": 70,
"language": "C++",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 25,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 24,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 25,
"open_issues": 24,
"watchers": 70,
"default_branch": "master"
},
{
"id": 169991818,
"node_id": "MDEwOlJlcG9zaXRvcnkxNjk5OTE4MTg=",
"name": "AddingSpeechToBots",
"full_name": "microsoft/AddingSpeechToBots",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AddingSpeechToBots",
"description": "Adding Speech to Conversational Bots",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AddingSpeechToBots",
"forks_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/forks",
"keys_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/events",
"assignees_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/merges",
"archive_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AddingSpeechToBots/deployments",
"created_at": "2019-02-10T15:19:28Z",
"updated_at": "2021-05-07T13:55:02Z",
"pushed_at": "2019-02-12T19:22:21Z",
"git_url": "git://github.com/microsoft/AddingSpeechToBots.git",
"ssh_url": "git@github.com:microsoft/AddingSpeechToBots.git",
"clone_url": "https://github.com/microsoft/AddingSpeechToBots.git",
"svn_url": "https://github.com/microsoft/AddingSpeechToBots",
"homepage": null,
"size": 30858,
"stargazers_count": 13,
"watchers_count": 13,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 14,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 0,
"license": null,
"forks": 14,
"open_issues": 0,
"watchers": 13,
"default_branch": "master"
},
{
"id": 173016559,
"node_id": "MDEwOlJlcG9zaXRvcnkxNzMwMTY1NTk=",
"name": "AddOutlookJapanHoliday",
"full_name": "microsoft/AddOutlookJapanHoliday",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AddOutlookJapanHoliday",
"description": "VBScript for adding Japan new Holidays to Outlook.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday",
"forks_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/forks",
"keys_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/events",
"assignees_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/merges",
"archive_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AddOutlookJapanHoliday/deployments",
"created_at": "2019-02-28T01:12:49Z",
"updated_at": "2021-08-13T16:11:32Z",
"pushed_at": "2021-08-13T16:11:28Z",
"git_url": "git://github.com/microsoft/AddOutlookJapanHoliday.git",
"ssh_url": "git@github.com:microsoft/AddOutlookJapanHoliday.git",
"clone_url": "https://github.com/microsoft/AddOutlookJapanHoliday.git",
"svn_url": "https://github.com/microsoft/AddOutlookJapanHoliday",
"homepage": "",
"size": 161,
"stargazers_count": 5,
"watchers_count": 5,
"language": "VBScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 9,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 9,
"open_issues": 0,
"watchers": 5,
"default_branch": "master"
},
{
"id": 250709608,
"node_id": "MDEwOlJlcG9zaXRvcnkyNTA3MDk2MDg=",
"name": "adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection",
"full_name": "microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection",
"description": "A sample AD FS 2019 Risk Assessment Model plug-in that blocks authentication or enforces MFA based on user risk level determined by Azure AD Identity Protection. ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection",
"forks_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection/deployments",
"created_at": "2020-03-28T03:53:58Z",
"updated_at": "2021-07-07T09:01:46Z",
"pushed_at": "2020-04-26T20:25:54Z",
"git_url": "git://github.com/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection.git",
"ssh_url": "git@github.com:microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection.git",
"clone_url": "https://github.com/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection.git",
"svn_url": "https://github.com/microsoft/adfs-sample-block-user-on-adfs-marked-risky-by-AzureAD-IdentityProtection",
"homepage": "",
"size": 1670,
"stargazers_count": 4,
"watchers_count": 4,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 1,
"watchers": 4,
"default_branch": "master"
},
{
"id": 202798124,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDI3OTgxMjQ=",
"name": "adfs-sample-msal-dotnet-native-to-webapi",
"full_name": "microsoft/adfs-sample-msal-dotnet-native-to-webapi",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-native-to-webapi",
"description": "A sample showcasing how to build a native app signing-in users authenticated by AD FS 2019 and acquiring tokens using MSAL library to call Web API.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi",
"forks_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-native-to-webapi/deployments",
"created_at": "2019-08-16T20:56:40Z",
"updated_at": "2021-03-10T15:05:46Z",
"pushed_at": "2019-08-16T22:11:54Z",
"git_url": "git://github.com/microsoft/adfs-sample-msal-dotnet-native-to-webapi.git",
"ssh_url": "git@github.com:microsoft/adfs-sample-msal-dotnet-native-to-webapi.git",
"clone_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-native-to-webapi.git",
"svn_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-native-to-webapi",
"homepage": null,
"size": 1668,
"stargazers_count": 5,
"watchers_count": 5,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 7,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 7,
"open_issues": 0,
"watchers": 5,
"default_branch": "master"
},
{
"id": 200916847,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDA5MTY4NDc=",
"name": "adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof",
"full_name": "microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof",
"description": "A sample showcasing how to implement an on-behalf-of (OBO) authentication using AD FS. The sample uses MSAL client library to obtain a token for accessing Web API. ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof",
"forks_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof/deployments",
"created_at": "2019-08-06T20:04:34Z",
"updated_at": "2021-03-21T15:39:57Z",
"pushed_at": "2019-08-21T21:12:23Z",
"git_url": "git://github.com/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof.git",
"ssh_url": "git@github.com:microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof.git",
"clone_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof.git",
"svn_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-webapi-to-webapi-onbehalfof",
"homepage": null,
"size": 2948,
"stargazers_count": 4,
"watchers_count": 4,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 0,
"watchers": 4,
"default_branch": "master"
},
{
"id": 202806359,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDI4MDYzNTk=",
"name": "adfs-sample-msal-dotnet-webapp-to-webapi",
"full_name": "microsoft/adfs-sample-msal-dotnet-webapp-to-webapi",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi",
"description": "A sample showcasing how to build a Web App signing-in users authenticated by AD FS 2019 and acquiring tokens using MSAL library to call Web API.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi",
"forks_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi/deployments",
"created_at": "2019-08-16T22:23:08Z",
"updated_at": "2021-07-01T19:42:48Z",
"pushed_at": "2019-08-16T23:15:56Z",
"git_url": "git://github.com/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi.git",
"ssh_url": "git@github.com:microsoft/adfs-sample-msal-dotnet-webapp-to-webapi.git",
"clone_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi.git",
"svn_url": "https://github.com/microsoft/adfs-sample-msal-dotnet-webapp-to-webapi",
"homepage": null,
"size": 1608,
"stargazers_count": 9,
"watchers_count": 9,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 10,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 10,
"open_issues": 0,
"watchers": 9,
"default_branch": "master"
},
{
"id": 181750380,
"node_id": "MDEwOlJlcG9zaXRvcnkxODE3NTAzODA=",
"name": "adfs-sample-RiskAssessmentModel-RiskyIPBlock",
"full_name": "microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock",
"description": "Sample plug-in to block authentication requests coming from specified extranet IPs. ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock",
"forks_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock/deployments",
"created_at": "2019-04-16T19:06:30Z",
"updated_at": "2020-04-26T09:29:00Z",
"pushed_at": "2019-04-17T22:04:31Z",
"git_url": "git://github.com/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock.git",
"ssh_url": "git@github.com:microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock.git",
"clone_url": "https://github.com/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock.git",
"svn_url": "https://github.com/microsoft/adfs-sample-RiskAssessmentModel-RiskyIPBlock",
"homepage": null,
"size": 19,
"stargazers_count": 3,
"watchers_count": 3,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 1,
"watchers": 3,
"default_branch": "master"
},
{
"id": 105046485,
"node_id": "MDEwOlJlcG9zaXRvcnkxMDUwNDY0ODU=",
"name": "adfsAuthAdapters",
"full_name": "microsoft/adfsAuthAdapters",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsAuthAdapters",
"description": "External authentication adapters for AD FS",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsAuthAdapters",
"forks_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsAuthAdapters/deployments",
"created_at": "2017-09-27T17:11:24Z",
"updated_at": "2021-06-10T19:16:42Z",
"pushed_at": "2018-09-20T18:09:08Z",
"git_url": "git://github.com/microsoft/adfsAuthAdapters.git",
"ssh_url": "git@github.com:microsoft/adfsAuthAdapters.git",
"clone_url": "https://github.com/microsoft/adfsAuthAdapters.git",
"svn_url": "https://github.com/microsoft/adfsAuthAdapters",
"homepage": null,
"size": 30,
"stargazers_count": 18,
"watchers_count": 18,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 10,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 10,
"open_issues": 0,
"watchers": 18,
"default_branch": "master"
},
{
"id": 104108234,
"node_id": "MDEwOlJlcG9zaXRvcnkxMDQxMDgyMzQ=",
"name": "adfsLogTools",
"full_name": "microsoft/adfsLogTools",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsLogTools",
"description": "Tools for parsing AD FS logs (admin events, audits, and debug logs)",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsLogTools",
"forks_url": "https://api.github.com/repos/microsoft/adfsLogTools/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsLogTools/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsLogTools/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsLogTools/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsLogTools/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsLogTools/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsLogTools/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsLogTools/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsLogTools/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsLogTools/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsLogTools/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsLogTools/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsLogTools/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsLogTools/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsLogTools/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsLogTools/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsLogTools/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsLogTools/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsLogTools/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsLogTools/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsLogTools/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsLogTools/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsLogTools/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsLogTools/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsLogTools/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsLogTools/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsLogTools/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsLogTools/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsLogTools/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsLogTools/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsLogTools/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsLogTools/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsLogTools/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsLogTools/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsLogTools/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsLogTools/deployments",
"created_at": "2017-09-19T17:49:07Z",
"updated_at": "2021-04-20T16:11:03Z",
"pushed_at": "2018-08-15T22:02:51Z",
"git_url": "git://github.com/microsoft/adfsLogTools.git",
"ssh_url": "git@github.com:microsoft/adfsLogTools.git",
"clone_url": "https://github.com/microsoft/adfsLogTools.git",
"svn_url": "https://github.com/microsoft/adfsLogTools",
"homepage": "",
"size": 56,
"stargazers_count": 21,
"watchers_count": 21,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 12,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 8,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 12,
"open_issues": 8,
"watchers": 21,
"default_branch": "master"
},
{
"id": 117035309,
"node_id": "MDEwOlJlcG9zaXRvcnkxMTcwMzUzMDk=",
"name": "adfsManagementTools",
"full_name": "microsoft/adfsManagementTools",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsManagementTools",
"description": "A collection of scripts and tools for managing ADFS",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsManagementTools",
"forks_url": "https://api.github.com/repos/microsoft/adfsManagementTools/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsManagementTools/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsManagementTools/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsManagementTools/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsManagementTools/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsManagementTools/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsManagementTools/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsManagementTools/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsManagementTools/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsManagementTools/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsManagementTools/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsManagementTools/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsManagementTools/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsManagementTools/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsManagementTools/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsManagementTools/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsManagementTools/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsManagementTools/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsManagementTools/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsManagementTools/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsManagementTools/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsManagementTools/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsManagementTools/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsManagementTools/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsManagementTools/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsManagementTools/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsManagementTools/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsManagementTools/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsManagementTools/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsManagementTools/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsManagementTools/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsManagementTools/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsManagementTools/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsManagementTools/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsManagementTools/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsManagementTools/deployments",
"created_at": "2018-01-11T01:51:11Z",
"updated_at": "2021-04-20T16:13:02Z",
"pushed_at": "2018-08-06T22:59:10Z",
"git_url": "git://github.com/microsoft/adfsManagementTools.git",
"ssh_url": "git@github.com:microsoft/adfsManagementTools.git",
"clone_url": "https://github.com/microsoft/adfsManagementTools.git",
"svn_url": "https://github.com/microsoft/adfsManagementTools",
"homepage": null,
"size": 166,
"stargazers_count": 13,
"watchers_count": 13,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 7,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 7,
"open_issues": 0,
"watchers": 13,
"default_branch": "master"
},
{
"id": 118157650,
"node_id": "MDEwOlJlcG9zaXRvcnkxMTgxNTc2NTA=",
"name": "adfsOpenSource",
"full_name": "microsoft/adfsOpenSource",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsOpenSource",
"description": "Documentation and guidance for ADFS Open Source",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsOpenSource",
"forks_url": "https://api.github.com/repos/microsoft/adfsOpenSource/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsOpenSource/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsOpenSource/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsOpenSource/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsOpenSource/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsOpenSource/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsOpenSource/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsOpenSource/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsOpenSource/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsOpenSource/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsOpenSource/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsOpenSource/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsOpenSource/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsOpenSource/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsOpenSource/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsOpenSource/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsOpenSource/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsOpenSource/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsOpenSource/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsOpenSource/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsOpenSource/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsOpenSource/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsOpenSource/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsOpenSource/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsOpenSource/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsOpenSource/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsOpenSource/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsOpenSource/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsOpenSource/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsOpenSource/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsOpenSource/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsOpenSource/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsOpenSource/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsOpenSource/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsOpenSource/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsOpenSource/deployments",
"created_at": "2018-01-19T17:41:20Z",
"updated_at": "2021-04-20T16:13:08Z",
"pushed_at": "2018-10-13T13:40:49Z",
"git_url": "git://github.com/microsoft/adfsOpenSource.git",
"ssh_url": "git@github.com:microsoft/adfsOpenSource.git",
"clone_url": "https://github.com/microsoft/adfsOpenSource.git",
"svn_url": "https://github.com/microsoft/adfsOpenSource",
"homepage": null,
"size": 117,
"stargazers_count": 8,
"watchers_count": 8,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 11,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 11,
"open_issues": 1,
"watchers": 8,
"default_branch": "master"
},
{
"id": 131890372,
"node_id": "MDEwOlJlcG9zaXRvcnkxMzE4OTAzNzI=",
"name": "adfsToolbox",
"full_name": "microsoft/adfsToolbox",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsToolbox",
"description": "A collection of PowerShell scripts for managing AD FS",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsToolbox",
"forks_url": "https://api.github.com/repos/microsoft/adfsToolbox/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsToolbox/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsToolbox/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsToolbox/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsToolbox/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsToolbox/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsToolbox/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsToolbox/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsToolbox/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsToolbox/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsToolbox/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsToolbox/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsToolbox/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsToolbox/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsToolbox/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsToolbox/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsToolbox/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsToolbox/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsToolbox/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsToolbox/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsToolbox/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsToolbox/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsToolbox/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsToolbox/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsToolbox/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsToolbox/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsToolbox/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsToolbox/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsToolbox/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsToolbox/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsToolbox/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsToolbox/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsToolbox/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsToolbox/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsToolbox/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsToolbox/deployments",
"created_at": "2018-05-02T18:24:35Z",
"updated_at": "2021-08-16T15:07:55Z",
"pushed_at": "2020-07-22T17:41:54Z",
"git_url": "git://github.com/microsoft/adfsToolbox.git",
"ssh_url": "git@github.com:microsoft/adfsToolbox.git",
"clone_url": "https://github.com/microsoft/adfsToolbox.git",
"svn_url": "https://github.com/microsoft/adfsToolbox",
"homepage": null,
"size": 402,
"stargazers_count": 89,
"watchers_count": 89,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 26,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 14,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 26,
"open_issues": 14,
"watchers": 89,
"default_branch": "master"
},
{
"id": 131075092,
"node_id": "MDEwOlJlcG9zaXRvcnkxMzEwNzUwOTI=",
"name": "adfsUITesting",
"full_name": "microsoft/adfsUITesting",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsUITesting",
"description": "Testing infrastructure for automated browser testing against AD FS",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsUITesting",
"forks_url": "https://api.github.com/repos/microsoft/adfsUITesting/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsUITesting/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsUITesting/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsUITesting/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsUITesting/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsUITesting/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsUITesting/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsUITesting/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsUITesting/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsUITesting/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsUITesting/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsUITesting/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsUITesting/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsUITesting/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsUITesting/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsUITesting/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsUITesting/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsUITesting/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsUITesting/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsUITesting/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsUITesting/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsUITesting/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsUITesting/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsUITesting/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsUITesting/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsUITesting/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsUITesting/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsUITesting/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsUITesting/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsUITesting/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsUITesting/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsUITesting/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsUITesting/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsUITesting/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsUITesting/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsUITesting/deployments",
"created_at": "2018-04-25T23:37:20Z",
"updated_at": "2021-04-20T16:15:13Z",
"pushed_at": "2018-04-26T00:01:46Z",
"git_url": "git://github.com/microsoft/adfsUITesting.git",
"ssh_url": "git@github.com:microsoft/adfsUITesting.git",
"clone_url": "https://github.com/microsoft/adfsUITesting.git",
"svn_url": "https://github.com/microsoft/adfsUITesting",
"homepage": "",
"size": 19,
"stargazers_count": 5,
"watchers_count": 5,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 1,
"watchers": 5,
"default_branch": "master"
},
{
"id": 104497482,
"node_id": "MDEwOlJlcG9zaXRvcnkxMDQ0OTc0ODI=",
"name": "adfsWebCustomization",
"full_name": "microsoft/adfsWebCustomization",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adfsWebCustomization",
"description": "A repository of useful Web Customizations for Active Directory Federation Services ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adfsWebCustomization",
"forks_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/forks",
"keys_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/events",
"assignees_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/merges",
"archive_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adfsWebCustomization/deployments",
"created_at": "2017-09-22T16:48:21Z",
"updated_at": "2021-06-15T22:22:30Z",
"pushed_at": "2020-06-04T02:00:21Z",
"git_url": "git://github.com/microsoft/adfsWebCustomization.git",
"ssh_url": "git@github.com:microsoft/adfsWebCustomization.git",
"clone_url": "https://github.com/microsoft/adfsWebCustomization.git",
"svn_url": "https://github.com/microsoft/adfsWebCustomization",
"homepage": null,
"size": 5168,
"stargazers_count": 87,
"watchers_count": 87,
"language": "JavaScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 66,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 22,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 66,
"open_issues": 22,
"watchers": 87,
"default_branch": "master"
},
{
"id": 228246102,
"node_id": "MDEwOlJlcG9zaXRvcnkyMjgyNDYxMDI=",
"name": "ado-ml-batch-train",
"full_name": "microsoft/ado-ml-batch-train",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ado-ml-batch-train",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/ado-ml-batch-train",
"forks_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/forks",
"keys_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/events",
"assignees_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/merges",
"archive_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ado-ml-batch-train/deployments",
"created_at": "2019-12-15T20:18:19Z",
"updated_at": "2020-04-26T09:29:42Z",
"pushed_at": "2020-01-24T08:19:40Z",
"git_url": "git://github.com/microsoft/ado-ml-batch-train.git",
"ssh_url": "git@github.com:microsoft/ado-ml-batch-train.git",
"clone_url": "https://github.com/microsoft/ado-ml-batch-train.git",
"svn_url": "https://github.com/microsoft/ado-ml-batch-train",
"homepage": null,
"size": 645,
"stargazers_count": 5,
"watchers_count": 5,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 3,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 3,
"open_issues": 2,
"watchers": 5,
"default_branch": "master"
},
{
"id": 192422785,
"node_id": "MDEwOlJlcG9zaXRvcnkxOTI0MjI3ODU=",
"name": "ads-extension-telemetry",
"full_name": "microsoft/ads-extension-telemetry",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ads-extension-telemetry",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/ads-extension-telemetry",
"forks_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/forks",
"keys_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/events",
"assignees_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/merges",
"archive_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ads-extension-telemetry/deployments",
"created_at": "2019-06-17T21:44:34Z",
"updated_at": "2021-06-22T21:21:59Z",
"pushed_at": "2021-06-22T21:21:57Z",
"git_url": "git://github.com/microsoft/ads-extension-telemetry.git",
"ssh_url": "git@github.com:microsoft/ads-extension-telemetry.git",
"clone_url": "https://github.com/microsoft/ads-extension-telemetry.git",
"svn_url": "https://github.com/microsoft/ads-extension-telemetry",
"homepage": null,
"size": 58,
"stargazers_count": 0,
"watchers_count": 0,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 3,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 3,
"open_issues": 0,
"watchers": 0,
"default_branch": "main"
},
{
"id": 359600603,
"node_id": "MDEwOlJlcG9zaXRvcnkzNTk2MDA2MDM=",
"name": "ads-kerberos",
"full_name": "microsoft/ads-kerberos",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ads-kerberos",
"description": "A package for providing kerberos authentication support in Azure Data Studio. ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ads-kerberos",
"forks_url": "https://api.github.com/repos/microsoft/ads-kerberos/forks",
"keys_url": "https://api.github.com/repos/microsoft/ads-kerberos/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ads-kerberos/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ads-kerberos/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ads-kerberos/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ads-kerberos/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ads-kerberos/events",
"assignees_url": "https://api.github.com/repos/microsoft/ads-kerberos/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ads-kerberos/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ads-kerberos/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ads-kerberos/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ads-kerberos/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ads-kerberos/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ads-kerberos/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ads-kerberos/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ads-kerberos/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ads-kerberos/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ads-kerberos/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ads-kerberos/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ads-kerberos/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ads-kerberos/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ads-kerberos/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ads-kerberos/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ads-kerberos/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ads-kerberos/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ads-kerberos/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ads-kerberos/merges",
"archive_url": "https://api.github.com/repos/microsoft/ads-kerberos/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ads-kerberos/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ads-kerberos/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ads-kerberos/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ads-kerberos/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ads-kerberos/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ads-kerberos/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ads-kerberos/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ads-kerberos/deployments",
"created_at": "2021-04-19T21:15:57Z",
"updated_at": "2021-04-19T22:08:59Z",
"pushed_at": "2021-08-13T01:08:20Z",
"git_url": "git://github.com/microsoft/ads-kerberos.git",
"ssh_url": "git@github.com:microsoft/ads-kerberos.git",
"clone_url": "https://github.com/microsoft/ads-kerberos.git",
"svn_url": "https://github.com/microsoft/ads-kerberos",
"homepage": null,
"size": 591,
"stargazers_count": 0,
"watchers_count": 0,
"language": "C++",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 1,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 9,
"license": {
"key": "apache-2.0",
"name": "Apache License 2.0",
"spdx_id": "Apache-2.0",
"url": "https://api.github.com/licenses/apache-2.0",
"node_id": "MDc6TGljZW5zZTI="
},
"forks": 1,
"open_issues": 9,
"watchers": 0,
"default_branch": "main"
},
{
"id": 190077719,
"node_id": "MDEwOlJlcG9zaXRvcnkxOTAwNzc3MTk=",
"name": "ads-service-downloader",
"full_name": "microsoft/ads-service-downloader",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ads-service-downloader",
"description": "Service downloader",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ads-service-downloader",
"forks_url": "https://api.github.com/repos/microsoft/ads-service-downloader/forks",
"keys_url": "https://api.github.com/repos/microsoft/ads-service-downloader/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ads-service-downloader/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ads-service-downloader/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ads-service-downloader/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ads-service-downloader/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ads-service-downloader/events",
"assignees_url": "https://api.github.com/repos/microsoft/ads-service-downloader/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ads-service-downloader/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ads-service-downloader/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ads-service-downloader/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ads-service-downloader/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ads-service-downloader/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ads-service-downloader/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ads-service-downloader/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ads-service-downloader/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ads-service-downloader/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ads-service-downloader/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ads-service-downloader/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ads-service-downloader/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ads-service-downloader/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ads-service-downloader/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ads-service-downloader/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ads-service-downloader/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ads-service-downloader/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ads-service-downloader/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ads-service-downloader/merges",
"archive_url": "https://api.github.com/repos/microsoft/ads-service-downloader/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ads-service-downloader/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ads-service-downloader/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ads-service-downloader/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ads-service-downloader/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ads-service-downloader/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ads-service-downloader/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ads-service-downloader/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ads-service-downloader/deployments",
"created_at": "2019-06-03T20:29:58Z",
"updated_at": "2021-08-04T18:09:46Z",
"pushed_at": "2021-08-04T18:10:34Z",
"git_url": "git://github.com/microsoft/ads-service-downloader.git",
"ssh_url": "git@github.com:microsoft/ads-service-downloader.git",
"clone_url": "https://github.com/microsoft/ads-service-downloader.git",
"svn_url": "https://github.com/microsoft/ads-service-downloader",
"homepage": null,
"size": 97,
"stargazers_count": 2,
"watchers_count": 2,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 10,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": null,
"forks": 10,
"open_issues": 0,
"watchers": 2,
"default_branch": "main"
},
{
"id": 150630983,
"node_id": "MDEwOlJlcG9zaXRvcnkxNTA2MzA5ODM=",
"name": "ADU",
"full_name": "microsoft/ADU",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ADU",
"description": "Appliance Diagnostic Utility (ADU) for Analytics Platform System (APS)",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ADU",
"forks_url": "https://api.github.com/repos/microsoft/ADU/forks",
"keys_url": "https://api.github.com/repos/microsoft/ADU/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ADU/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ADU/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ADU/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ADU/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ADU/events",
"assignees_url": "https://api.github.com/repos/microsoft/ADU/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ADU/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ADU/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ADU/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ADU/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ADU/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ADU/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ADU/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ADU/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ADU/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ADU/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ADU/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ADU/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ADU/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ADU/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ADU/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ADU/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ADU/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ADU/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ADU/merges",
"archive_url": "https://api.github.com/repos/microsoft/ADU/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ADU/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ADU/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ADU/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ADU/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ADU/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ADU/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ADU/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ADU/deployments",
"created_at": "2018-09-27T18:29:25Z",
"updated_at": "2021-07-28T15:15:45Z",
"pushed_at": "2021-07-28T15:15:42Z",
"git_url": "git://github.com/microsoft/ADU.git",
"ssh_url": "git@github.com:microsoft/ADU.git",
"clone_url": "https://github.com/microsoft/ADU.git",
"svn_url": "https://github.com/microsoft/ADU",
"homepage": null,
"size": 237,
"stargazers_count": 5,
"watchers_count": 5,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 7,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 7,
"open_issues": 0,
"watchers": 5,
"default_branch": "master"
},
{
"id": 95923092,
"node_id": "MDEwOlJlcG9zaXRvcnk5NTkyMzA5Mg==",
"name": "Advanced-Threat-Analytics",
"full_name": "microsoft/Advanced-Threat-Analytics",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/Advanced-Threat-Analytics",
"description": "ATA PowerShell Module",
"fork": false,
"url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics",
"forks_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/forks",
"keys_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/teams",
"hooks_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/events",
"assignees_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/tags",
"blobs_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/subscription",
"commits_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/merges",
"archive_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/downloads",
"issues_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/Advanced-Threat-Analytics/deployments",
"created_at": "2017-06-30T20:49:53Z",
"updated_at": "2021-04-20T16:09:43Z",
"pushed_at": "2017-11-20T21:47:43Z",
"git_url": "git://github.com/microsoft/Advanced-Threat-Analytics.git",
"ssh_url": "git@github.com:microsoft/Advanced-Threat-Analytics.git",
"clone_url": "https://github.com/microsoft/Advanced-Threat-Analytics.git",
"svn_url": "https://github.com/microsoft/Advanced-Threat-Analytics",
"homepage": null,
"size": 46,
"stargazers_count": 28,
"watchers_count": 28,
"language": "PowerShell",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 12,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 12,
"open_issues": 2,
"watchers": 28,
"default_branch": "master"
},
{
"id": 54745974,
"node_id": "MDEwOlJlcG9zaXRvcnk1NDc0NTk3NA==",
"name": "AdventureWorksSkiApp",
"full_name": "microsoft/AdventureWorksSkiApp",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AdventureWorksSkiApp",
"description": "The AdventureWorks Ski App provides a sample application that can be used to demonstrate the value of building in intelligence into an existing application. This app was first demoed at //build 2016.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp",
"forks_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/forks",
"keys_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/events",
"assignees_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/merges",
"archive_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AdventureWorksSkiApp/deployments",
"created_at": "2016-03-25T20:33:04Z",
"updated_at": "2021-06-24T11:26:41Z",
"pushed_at": "2017-05-24T22:00:19Z",
"git_url": "git://github.com/microsoft/AdventureWorksSkiApp.git",
"ssh_url": "git@github.com:microsoft/AdventureWorksSkiApp.git",
"clone_url": "https://github.com/microsoft/AdventureWorksSkiApp.git",
"svn_url": "https://github.com/microsoft/AdventureWorksSkiApp",
"homepage": "https://channel9.msdn.com/Events/Build/2016/B857",
"size": 124741,
"stargazers_count": 63,
"watchers_count": 63,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 37,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 37,
"open_issues": 0,
"watchers": 63,
"default_branch": "intelligent"
},
{
"id": 306104666,
"node_id": "MDEwOlJlcG9zaXRvcnkzMDYxMDQ2NjY=",
"name": "AdversarialGMM",
"full_name": "microsoft/AdversarialGMM",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AdversarialGMM",
"description": "Minimax Estimation of Conditional Moment Models",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AdversarialGMM",
"forks_url": "https://api.github.com/repos/microsoft/AdversarialGMM/forks",
"keys_url": "https://api.github.com/repos/microsoft/AdversarialGMM/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AdversarialGMM/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AdversarialGMM/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AdversarialGMM/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AdversarialGMM/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AdversarialGMM/events",
"assignees_url": "https://api.github.com/repos/microsoft/AdversarialGMM/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AdversarialGMM/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AdversarialGMM/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AdversarialGMM/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AdversarialGMM/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AdversarialGMM/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AdversarialGMM/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AdversarialGMM/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AdversarialGMM/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AdversarialGMM/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AdversarialGMM/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AdversarialGMM/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AdversarialGMM/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AdversarialGMM/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AdversarialGMM/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AdversarialGMM/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AdversarialGMM/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AdversarialGMM/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AdversarialGMM/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AdversarialGMM/merges",
"archive_url": "https://api.github.com/repos/microsoft/AdversarialGMM/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AdversarialGMM/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AdversarialGMM/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AdversarialGMM/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AdversarialGMM/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AdversarialGMM/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AdversarialGMM/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AdversarialGMM/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AdversarialGMM/deployments",
"created_at": "2020-10-21T17:49:34Z",
"updated_at": "2021-08-04T13:44:13Z",
"pushed_at": "2020-10-21T20:23:22Z",
"git_url": "git://github.com/microsoft/AdversarialGMM.git",
"ssh_url": "git@github.com:microsoft/AdversarialGMM.git",
"clone_url": "https://github.com/microsoft/AdversarialGMM.git",
"svn_url": "https://github.com/microsoft/AdversarialGMM",
"homepage": "",
"size": 5052,
"stargazers_count": 20,
"watchers_count": 20,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 6,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 6,
"open_issues": 0,
"watchers": 20,
"default_branch": "main"
},
{
"id": 343808019,
"node_id": "MDEwOlJlcG9zaXRvcnkzNDM4MDgwMTk=",
"name": "advertising-content-api-java",
"full_name": "microsoft/advertising-content-api-java",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/advertising-content-api-java",
"description": "Microsoft Advertising Java SDK for Content API",
"fork": false,
"url": "https://api.github.com/repos/microsoft/advertising-content-api-java",
"forks_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/forks",
"keys_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/teams",
"hooks_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/events",
"assignees_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/tags",
"blobs_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/subscription",
"commits_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/merges",
"archive_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/downloads",
"issues_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/advertising-content-api-java/deployments",
"created_at": "2021-03-02T14:47:12Z",
"updated_at": "2021-03-02T14:47:20Z",
"pushed_at": "2021-03-02T14:47:19Z",
"git_url": "git://github.com/microsoft/advertising-content-api-java.git",
"ssh_url": "git@github.com:microsoft/advertising-content-api-java.git",
"clone_url": "https://github.com/microsoft/advertising-content-api-java.git",
"svn_url": "https://github.com/microsoft/advertising-content-api-java",
"homepage": null,
"size": 6,
"stargazers_count": 0,
"watchers_count": 0,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 0,
"watchers": 0,
"default_branch": "main"
},
{
"id": 192029732,
"node_id": "MDEwOlJlcG9zaXRvcnkxOTIwMjk3MzI=",
"name": "AdvocacyPlatform",
"full_name": "microsoft/AdvocacyPlatform",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AdvocacyPlatform",
"description": "The Advocacy Platform is a cloud solution to automate the acquisition of case decisions, court hearings and location information from the EOIR hotline. Additionally, this solution helps NGOs working with Asylum seeker families at risk of deportation to allocate legal professionals/volunteers more efficiently.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AdvocacyPlatform",
"forks_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/forks",
"keys_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/events",
"assignees_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/merges",
"archive_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AdvocacyPlatform/deployments",
"created_at": "2019-06-15T02:57:20Z",
"updated_at": "2021-02-24T05:49:16Z",
"pushed_at": "2019-07-15T02:31:08Z",
"git_url": "git://github.com/microsoft/AdvocacyPlatform.git",
"ssh_url": "git@github.com:microsoft/AdvocacyPlatform.git",
"clone_url": "https://github.com/microsoft/AdvocacyPlatform.git",
"svn_url": "https://github.com/microsoft/AdvocacyPlatform",
"homepage": null,
"size": 10662,
"stargazers_count": 6,
"watchers_count": 6,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 7,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 7,
"open_issues": 0,
"watchers": 6,
"default_branch": "master"
},
{
"id": 220807429,
"node_id": "MDEwOlJlcG9zaXRvcnkyMjA4MDc0Mjk=",
"name": "adx-query-charts",
"full_name": "microsoft/adx-query-charts",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/adx-query-charts",
"description": "Draw charts from Azure Data Explorer queries",
"fork": false,
"url": "https://api.github.com/repos/microsoft/adx-query-charts",
"forks_url": "https://api.github.com/repos/microsoft/adx-query-charts/forks",
"keys_url": "https://api.github.com/repos/microsoft/adx-query-charts/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/adx-query-charts/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/adx-query-charts/teams",
"hooks_url": "https://api.github.com/repos/microsoft/adx-query-charts/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/adx-query-charts/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/adx-query-charts/events",
"assignees_url": "https://api.github.com/repos/microsoft/adx-query-charts/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/adx-query-charts/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/adx-query-charts/tags",
"blobs_url": "https://api.github.com/repos/microsoft/adx-query-charts/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/adx-query-charts/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/adx-query-charts/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/adx-query-charts/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/adx-query-charts/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/adx-query-charts/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/adx-query-charts/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/adx-query-charts/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/adx-query-charts/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/adx-query-charts/subscription",
"commits_url": "https://api.github.com/repos/microsoft/adx-query-charts/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/adx-query-charts/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/adx-query-charts/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/adx-query-charts/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/adx-query-charts/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/adx-query-charts/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/adx-query-charts/merges",
"archive_url": "https://api.github.com/repos/microsoft/adx-query-charts/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/adx-query-charts/downloads",
"issues_url": "https://api.github.com/repos/microsoft/adx-query-charts/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/adx-query-charts/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/adx-query-charts/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/adx-query-charts/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/adx-query-charts/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/adx-query-charts/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/adx-query-charts/deployments",
"created_at": "2019-11-10T15:12:49Z",
"updated_at": "2021-05-12T08:15:31Z",
"pushed_at": "2021-08-11T18:19:15Z",
"git_url": "git://github.com/microsoft/adx-query-charts.git",
"ssh_url": "git@github.com:microsoft/adx-query-charts.git",
"clone_url": "https://github.com/microsoft/adx-query-charts.git",
"svn_url": "https://github.com/microsoft/adx-query-charts",
"homepage": null,
"size": 827,
"stargazers_count": 10,
"watchers_count": 10,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 6,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 6,
"open_issues": 1,
"watchers": 10,
"default_branch": "master"
},
{
"id": 292698088,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTI2OTgwODg=",
"name": "AEC-Challenge",
"full_name": "microsoft/AEC-Challenge",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AEC-Challenge",
"description": "AEC Challenge",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AEC-Challenge",
"forks_url": "https://api.github.com/repos/microsoft/AEC-Challenge/forks",
"keys_url": "https://api.github.com/repos/microsoft/AEC-Challenge/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AEC-Challenge/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AEC-Challenge/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AEC-Challenge/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AEC-Challenge/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AEC-Challenge/events",
"assignees_url": "https://api.github.com/repos/microsoft/AEC-Challenge/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AEC-Challenge/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AEC-Challenge/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AEC-Challenge/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AEC-Challenge/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AEC-Challenge/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AEC-Challenge/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AEC-Challenge/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AEC-Challenge/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AEC-Challenge/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AEC-Challenge/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AEC-Challenge/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AEC-Challenge/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AEC-Challenge/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AEC-Challenge/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AEC-Challenge/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AEC-Challenge/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AEC-Challenge/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AEC-Challenge/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AEC-Challenge/merges",
"archive_url": "https://api.github.com/repos/microsoft/AEC-Challenge/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AEC-Challenge/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AEC-Challenge/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AEC-Challenge/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AEC-Challenge/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AEC-Challenge/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AEC-Challenge/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AEC-Challenge/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AEC-Challenge/deployments",
"created_at": "2020-09-03T23:04:10Z",
"updated_at": "2021-08-21T03:59:27Z",
"pushed_at": "2021-06-15T16:56:35Z",
"git_url": "git://github.com/microsoft/AEC-Challenge.git",
"ssh_url": "git@github.com:microsoft/AEC-Challenge.git",
"clone_url": "https://github.com/microsoft/AEC-Challenge.git",
"svn_url": "https://github.com/microsoft/AEC-Challenge",
"homepage": null,
"size": 160415,
"stargazers_count": 131,
"watchers_count": 131,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 57,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 4,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 57,
"open_issues": 4,
"watchers": 131,
"default_branch": "main"
},
{
"id": 291118051,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTExMTgwNTE=",
"name": "aed-blockchain-learn-content",
"full_name": "microsoft/aed-blockchain-learn-content",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-blockchain-learn-content",
"description": "Beta content for blockchain Learn modules",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content",
"forks_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-blockchain-learn-content/deployments",
"created_at": "2020-08-28T18:24:37Z",
"updated_at": "2021-07-12T00:03:26Z",
"pushed_at": "2021-03-10T20:59:56Z",
"git_url": "git://github.com/microsoft/aed-blockchain-learn-content.git",
"ssh_url": "git@github.com:microsoft/aed-blockchain-learn-content.git",
"clone_url": "https://github.com/microsoft/aed-blockchain-learn-content.git",
"svn_url": "https://github.com/microsoft/aed-blockchain-learn-content",
"homepage": null,
"size": 20867,
"stargazers_count": 3,
"watchers_count": 3,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 9,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 9,
"open_issues": 0,
"watchers": 3,
"default_branch": "main"
},
{
"id": 273306872,
"node_id": "MDEwOlJlcG9zaXRvcnkyNzMzMDY4NzI=",
"name": "aed-content-nasa-su20",
"full_name": "microsoft/aed-content-nasa-su20",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-content-nasa-su20",
"description": "This is the beta content for the learn modules that we are creating for NASA for 2020 internship",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20",
"forks_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-content-nasa-su20/deployments",
"created_at": "2020-06-18T18:03:03Z",
"updated_at": "2020-11-10T19:15:10Z",
"pushed_at": "2020-12-12T04:53:23Z",
"git_url": "git://github.com/microsoft/aed-content-nasa-su20.git",
"ssh_url": "git@github.com:microsoft/aed-content-nasa-su20.git",
"clone_url": "https://github.com/microsoft/aed-content-nasa-su20.git",
"svn_url": "https://github.com/microsoft/aed-content-nasa-su20",
"homepage": null,
"size": 19261,
"stargazers_count": 0,
"watchers_count": 0,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 6,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 6,
"open_issues": 1,
"watchers": 0,
"default_branch": "main"
},
{
"id": 311789550,
"node_id": "MDEwOlJlcG9zaXRvcnkzMTE3ODk1NTA=",
"name": "aed-external-learn-template",
"full_name": "microsoft/aed-external-learn-template",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-external-learn-template",
"description": "Template for creating Learn modules and Learning Paths",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-external-learn-template",
"forks_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-external-learn-template/deployments",
"created_at": "2020-11-10T21:30:58Z",
"updated_at": "2020-11-10T21:31:06Z",
"pushed_at": "2020-11-10T21:31:03Z",
"git_url": "git://github.com/microsoft/aed-external-learn-template.git",
"ssh_url": "git@github.com:microsoft/aed-external-learn-template.git",
"clone_url": "https://github.com/microsoft/aed-external-learn-template.git",
"svn_url": "https://github.com/microsoft/aed-external-learn-template",
"homepage": null,
"size": 12,
"stargazers_count": 0,
"watchers_count": 0,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 0,
"open_issues": 0,
"watchers": 0,
"default_branch": "main"
},
{
"id": 304393287,
"node_id": "MDEwOlJlcG9zaXRvcnkzMDQzOTMyODc=",
"name": "aed-go-learn-content",
"full_name": "microsoft/aed-go-learn-content",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-go-learn-content",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-go-learn-content",
"forks_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-go-learn-content/deployments",
"created_at": "2020-10-15T16:58:35Z",
"updated_at": "2021-05-06T15:03:44Z",
"pushed_at": "2021-03-10T20:57:00Z",
"git_url": "git://github.com/microsoft/aed-go-learn-content.git",
"ssh_url": "git@github.com:microsoft/aed-go-learn-content.git",
"clone_url": "https://github.com/microsoft/aed-go-learn-content.git",
"svn_url": "https://github.com/microsoft/aed-go-learn-content",
"homepage": null,
"size": 387,
"stargazers_count": 5,
"watchers_count": 5,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 0,
"watchers": 5,
"default_branch": "main"
},
{
"id": 291881059,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTE4ODEwNTk=",
"name": "aed-learn-template",
"full_name": "microsoft/aed-learn-template",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-learn-template",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-learn-template",
"forks_url": "https://api.github.com/repos/microsoft/aed-learn-template/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-learn-template/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-learn-template/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-learn-template/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-learn-template/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-learn-template/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-learn-template/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-learn-template/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-learn-template/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-learn-template/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-learn-template/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-learn-template/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-learn-template/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-learn-template/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-learn-template/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-learn-template/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-learn-template/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-learn-template/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-learn-template/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-learn-template/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-learn-template/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-learn-template/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-learn-template/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-learn-template/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-learn-template/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-learn-template/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-learn-template/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-learn-template/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-learn-template/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-learn-template/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-learn-template/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-learn-template/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-learn-template/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-learn-template/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-learn-template/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-learn-template/deployments",
"created_at": "2020-09-01T02:58:48Z",
"updated_at": "2021-07-06T16:53:44Z",
"pushed_at": "2021-06-28T23:40:54Z",
"git_url": "git://github.com/microsoft/aed-learn-template.git",
"ssh_url": "git@github.com:microsoft/aed-learn-template.git",
"clone_url": "https://github.com/microsoft/aed-learn-template.git",
"svn_url": "https://github.com/microsoft/aed-learn-template",
"homepage": null,
"size": 172,
"stargazers_count": 2,
"watchers_count": 2,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": false,
"has_pages": false,
"forks_count": 6,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 6,
"open_issues": 0,
"watchers": 2,
"default_branch": "main"
},
{
"id": 304393160,
"node_id": "MDEwOlJlcG9zaXRvcnkzMDQzOTMxNjA=",
"name": "aed-rust-learn-content",
"full_name": "microsoft/aed-rust-learn-content",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-rust-learn-content",
"description": "Rust learning path content development repo.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-rust-learn-content",
"forks_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-rust-learn-content/deployments",
"created_at": "2020-10-15T16:57:58Z",
"updated_at": "2021-07-06T10:14:42Z",
"pushed_at": "2021-05-04T01:57:44Z",
"git_url": "git://github.com/microsoft/aed-rust-learn-content.git",
"ssh_url": "git@github.com:microsoft/aed-rust-learn-content.git",
"clone_url": "https://github.com/microsoft/aed-rust-learn-content.git",
"svn_url": "https://github.com/microsoft/aed-rust-learn-content",
"homepage": "",
"size": 373,
"stargazers_count": 14,
"watchers_count": 14,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 12,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 12,
"open_issues": 0,
"watchers": 14,
"default_branch": "main"
},
{
"id": 291882204,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTE4ODIyMDQ=",
"name": "aed-wonder-woman",
"full_name": "microsoft/aed-wonder-woman",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aed-wonder-woman",
"description": null,
"fork": false,
"url": "https://api.github.com/repos/microsoft/aed-wonder-woman",
"forks_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/forks",
"keys_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/events",
"assignees_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/merges",
"archive_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aed-wonder-woman/deployments",
"created_at": "2020-09-01T03:05:22Z",
"updated_at": "2020-09-09T02:27:57Z",
"pushed_at": "2020-09-12T01:08:55Z",
"git_url": "git://github.com/microsoft/aed-wonder-woman.git",
"ssh_url": "git@github.com:microsoft/aed-wonder-woman.git",
"clone_url": "https://github.com/microsoft/aed-wonder-woman.git",
"svn_url": "https://github.com/microsoft/aed-wonder-woman",
"homepage": null,
"size": 37808,
"stargazers_count": 0,
"watchers_count": 0,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 0,
"open_issues": 0,
"watchers": 0,
"default_branch": "main"
},
{
"id": 197671887,
"node_id": "MDEwOlJlcG9zaXRvcnkxOTc2NzE4ODc=",
"name": "aerial_wildlife_detection",
"full_name": "microsoft/aerial_wildlife_detection",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/aerial_wildlife_detection",
"description": "Tools for detecting wildlife in aerial images using active learning",
"fork": false,
"url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection",
"forks_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/forks",
"keys_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/teams",
"hooks_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/events",
"assignees_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/tags",
"blobs_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/subscription",
"commits_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/merges",
"archive_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/downloads",
"issues_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/aerial_wildlife_detection/deployments",
"created_at": "2019-07-18T23:58:41Z",
"updated_at": "2021-08-13T14:48:05Z",
"pushed_at": "2021-08-04T17:05:13Z",
"git_url": "git://github.com/microsoft/aerial_wildlife_detection.git",
"ssh_url": "git@github.com:microsoft/aerial_wildlife_detection.git",
"clone_url": "https://github.com/microsoft/aerial_wildlife_detection.git",
"svn_url": "https://github.com/microsoft/aerial_wildlife_detection",
"homepage": "",
"size": 33763,
"stargazers_count": 130,
"watchers_count": 130,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 42,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 19,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 42,
"open_issues": 19,
"watchers": 130,
"default_branch": "master"
},
{
"id": 234608848,
"node_id": "MDEwOlJlcG9zaXRvcnkyMzQ2MDg4NDg=",
"name": "affectbased",
"full_name": "microsoft/affectbased",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/affectbased",
"description": "Affect-based Intrinsic Rewards for Learning General Representations: https://arxiv.org/abs/1912.00403",
"fork": false,
"url": "https://api.github.com/repos/microsoft/affectbased",
"forks_url": "https://api.github.com/repos/microsoft/affectbased/forks",
"keys_url": "https://api.github.com/repos/microsoft/affectbased/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/affectbased/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/affectbased/teams",
"hooks_url": "https://api.github.com/repos/microsoft/affectbased/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/affectbased/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/affectbased/events",
"assignees_url": "https://api.github.com/repos/microsoft/affectbased/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/affectbased/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/affectbased/tags",
"blobs_url": "https://api.github.com/repos/microsoft/affectbased/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/affectbased/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/affectbased/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/affectbased/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/affectbased/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/affectbased/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/affectbased/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/affectbased/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/affectbased/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/affectbased/subscription",
"commits_url": "https://api.github.com/repos/microsoft/affectbased/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/affectbased/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/affectbased/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/affectbased/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/affectbased/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/affectbased/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/affectbased/merges",
"archive_url": "https://api.github.com/repos/microsoft/affectbased/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/affectbased/downloads",
"issues_url": "https://api.github.com/repos/microsoft/affectbased/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/affectbased/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/affectbased/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/affectbased/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/affectbased/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/affectbased/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/affectbased/deployments",
"created_at": "2020-01-17T18:14:21Z",
"updated_at": "2021-05-28T00:19:30Z",
"pushed_at": "2020-11-13T17:42:31Z",
"git_url": "git://github.com/microsoft/affectbased.git",
"ssh_url": "git@github.com:microsoft/affectbased.git",
"clone_url": "https://github.com/microsoft/affectbased.git",
"svn_url": "https://github.com/microsoft/affectbased",
"homepage": null,
"size": 52201,
"stargazers_count": 6,
"watchers_count": 6,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 1,
"watchers": 6,
"default_branch": "master"
},
{
"id": 218607748,
"node_id": "MDEwOlJlcG9zaXRvcnkyMTg2MDc3NDg=",
"name": "AFUN-Demos",
"full_name": "microsoft/AFUN-Demos",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AFUN-Demos",
"description": "Demos for AFUN content for Microsoft Ignite the Tour content ",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AFUN-Demos",
"forks_url": "https://api.github.com/repos/microsoft/AFUN-Demos/forks",
"keys_url": "https://api.github.com/repos/microsoft/AFUN-Demos/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AFUN-Demos/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AFUN-Demos/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AFUN-Demos/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AFUN-Demos/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AFUN-Demos/events",
"assignees_url": "https://api.github.com/repos/microsoft/AFUN-Demos/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AFUN-Demos/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AFUN-Demos/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AFUN-Demos/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AFUN-Demos/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AFUN-Demos/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AFUN-Demos/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AFUN-Demos/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AFUN-Demos/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AFUN-Demos/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AFUN-Demos/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AFUN-Demos/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AFUN-Demos/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AFUN-Demos/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AFUN-Demos/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AFUN-Demos/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AFUN-Demos/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AFUN-Demos/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AFUN-Demos/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AFUN-Demos/merges",
"archive_url": "https://api.github.com/repos/microsoft/AFUN-Demos/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AFUN-Demos/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AFUN-Demos/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AFUN-Demos/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AFUN-Demos/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AFUN-Demos/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AFUN-Demos/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AFUN-Demos/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AFUN-Demos/deployments",
"created_at": "2019-10-30T19:36:30Z",
"updated_at": "2021-05-17T15:03:57Z",
"pushed_at": "2019-10-30T19:44:42Z",
"git_url": "git://github.com/microsoft/AFUN-Demos.git",
"ssh_url": "git@github.com:microsoft/AFUN-Demos.git",
"clone_url": "https://github.com/microsoft/AFUN-Demos.git",
"svn_url": "https://github.com/microsoft/AFUN-Demos",
"homepage": null,
"size": 7354,
"stargazers_count": 4,
"watchers_count": 4,
"language": "HTML",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 0,
"watchers": 4,
"default_branch": "master"
},
{
"id": 398318609,
"node_id": "MDEwOlJlcG9zaXRvcnkzOTgzMTg2MDk=",
"name": "agdiag",
"full_name": "microsoft/agdiag",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/agdiag",
"description": "Diagnose AlwaysOn health events like failover events, and failure to failover events",
"fork": false,
"url": "https://api.github.com/repos/microsoft/agdiag",
"forks_url": "https://api.github.com/repos/microsoft/agdiag/forks",
"keys_url": "https://api.github.com/repos/microsoft/agdiag/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/agdiag/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/agdiag/teams",
"hooks_url": "https://api.github.com/repos/microsoft/agdiag/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/agdiag/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/agdiag/events",
"assignees_url": "https://api.github.com/repos/microsoft/agdiag/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/agdiag/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/agdiag/tags",
"blobs_url": "https://api.github.com/repos/microsoft/agdiag/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/agdiag/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/agdiag/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/agdiag/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/agdiag/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/agdiag/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/agdiag/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/agdiag/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/agdiag/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/agdiag/subscription",
"commits_url": "https://api.github.com/repos/microsoft/agdiag/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/agdiag/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/agdiag/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/agdiag/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/agdiag/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/agdiag/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/agdiag/merges",
"archive_url": "https://api.github.com/repos/microsoft/agdiag/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/agdiag/downloads",
"issues_url": "https://api.github.com/repos/microsoft/agdiag/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/agdiag/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/agdiag/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/agdiag/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/agdiag/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/agdiag/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/agdiag/deployments",
"created_at": "2021-08-20T15:20:16Z",
"updated_at": "2021-08-20T15:20:24Z",
"pushed_at": "2021-08-20T15:20:22Z",
"git_url": "git://github.com/microsoft/agdiag.git",
"ssh_url": "git@github.com:microsoft/agdiag.git",
"clone_url": "https://github.com/microsoft/agdiag.git",
"svn_url": "https://github.com/microsoft/agdiag",
"homepage": null,
"size": 8,
"stargazers_count": 0,
"watchers_count": 0,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 0,
"watchers": 0,
"default_branch": "main"
},
{
"id": 149111328,
"node_id": "MDEwOlJlcG9zaXRvcnkxNDkxMTEzMjg=",
"name": "agogosml",
"full_name": "microsoft/agogosml",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/agogosml",
"description": "agogosml is a flexible data processing pipeline that addresses the common need for operationalizing ML models at scale",
"fork": false,
"url": "https://api.github.com/repos/microsoft/agogosml",
"forks_url": "https://api.github.com/repos/microsoft/agogosml/forks",
"keys_url": "https://api.github.com/repos/microsoft/agogosml/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/agogosml/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/agogosml/teams",
"hooks_url": "https://api.github.com/repos/microsoft/agogosml/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/agogosml/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/agogosml/events",
"assignees_url": "https://api.github.com/repos/microsoft/agogosml/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/agogosml/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/agogosml/tags",
"blobs_url": "https://api.github.com/repos/microsoft/agogosml/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/agogosml/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/agogosml/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/agogosml/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/agogosml/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/agogosml/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/agogosml/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/agogosml/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/agogosml/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/agogosml/subscription",
"commits_url": "https://api.github.com/repos/microsoft/agogosml/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/agogosml/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/agogosml/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/agogosml/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/agogosml/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/agogosml/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/agogosml/merges",
"archive_url": "https://api.github.com/repos/microsoft/agogosml/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/agogosml/downloads",
"issues_url": "https://api.github.com/repos/microsoft/agogosml/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/agogosml/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/agogosml/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/agogosml/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/agogosml/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/agogosml/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/agogosml/deployments",
"created_at": "2018-09-17T10:54:51Z",
"updated_at": "2021-04-20T16:17:51Z",
"pushed_at": "2019-05-03T20:28:35Z",
"git_url": "git://github.com/microsoft/agogosml.git",
"ssh_url": "git@github.com:microsoft/agogosml.git",
"clone_url": "https://github.com/microsoft/agogosml.git",
"svn_url": "https://github.com/microsoft/agogosml",
"homepage": null,
"size": 3347,
"stargazers_count": 36,
"watchers_count": 36,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 17,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 13,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 17,
"open_issues": 13,
"watchers": 36,
"default_branch": "master"
},
{
"id": 169285878,
"node_id": "MDEwOlJlcG9zaXRvcnkxNjkyODU4Nzg=",
"name": "AHS-AppServiceDotNet",
"full_name": "microsoft/AHS-AppServiceDotNet",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AHS-AppServiceDotNet",
"description": "Code for SmartHotel 360 Registration app for the AHS",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet",
"forks_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/forks",
"keys_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/events",
"assignees_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/merges",
"archive_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AHS-AppServiceDotNet/deployments",
"created_at": "2019-02-05T17:57:05Z",
"updated_at": "2021-04-20T16:20:45Z",
"pushed_at": "2019-02-05T17:59:49Z",
"git_url": "git://github.com/microsoft/AHS-AppServiceDotNet.git",
"ssh_url": "git@github.com:microsoft/AHS-AppServiceDotNet.git",
"clone_url": "https://github.com/microsoft/AHS-AppServiceDotNet.git",
"svn_url": "https://github.com/microsoft/AHS-AppServiceDotNet",
"homepage": null,
"size": 7196,
"stargazers_count": 3,
"watchers_count": 3,
"language": "JavaScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 8,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 8,
"open_issues": 0,
"watchers": 3,
"default_branch": "master"
},
{
"id": 206429675,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDY0Mjk2NzU=",
"name": "AI",
"full_name": "microsoft/AI",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AI",
"description": "Microsoft AI",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AI",
"forks_url": "https://api.github.com/repos/microsoft/AI/forks",
"keys_url": "https://api.github.com/repos/microsoft/AI/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AI/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AI/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AI/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AI/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AI/events",
"assignees_url": "https://api.github.com/repos/microsoft/AI/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AI/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AI/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AI/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AI/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AI/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AI/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AI/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AI/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AI/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AI/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AI/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AI/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AI/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AI/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AI/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AI/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AI/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AI/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AI/merges",
"archive_url": "https://api.github.com/repos/microsoft/AI/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AI/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AI/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AI/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AI/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AI/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AI/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AI/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AI/deployments",
"created_at": "2019-09-04T22:59:06Z",
"updated_at": "2021-08-17T06:52:25Z",
"pushed_at": "2021-03-16T23:11:04Z",
"git_url": "git://github.com/microsoft/AI.git",
"ssh_url": "git@github.com:microsoft/AI.git",
"clone_url": "https://github.com/microsoft/AI.git",
"svn_url": "https://github.com/microsoft/AI",
"homepage": "https://www.microsoft.com/ai",
"size": 24175,
"stargazers_count": 378,
"watchers_count": 378,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 109,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 109,
"open_issues": 0,
"watchers": 378,
"default_branch": "master"
},
{
"id": 240129180,
"node_id": "MDEwOlJlcG9zaXRvcnkyNDAxMjkxODA=",
"name": "ai-architecture-template",
"full_name": "microsoft/ai-architecture-template",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-architecture-template",
"description": "Base Python Template for Microsoft AI Azure Architectures",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-architecture-template",
"forks_url": "https://api.github.com/repos/microsoft/ai-architecture-template/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-architecture-template/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-architecture-template/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-architecture-template/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-architecture-template/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-architecture-template/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-architecture-template/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-architecture-template/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-architecture-template/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-architecture-template/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-architecture-template/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-architecture-template/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-architecture-template/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-architecture-template/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-architecture-template/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-architecture-template/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-architecture-template/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-architecture-template/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-architecture-template/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-architecture-template/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-architecture-template/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-architecture-template/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-architecture-template/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-architecture-template/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-architecture-template/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-architecture-template/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-architecture-template/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-architecture-template/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-architecture-template/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-architecture-template/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-architecture-template/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-architecture-template/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-architecture-template/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-architecture-template/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-architecture-template/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-architecture-template/deployments",
"created_at": "2020-02-12T22:33:32Z",
"updated_at": "2021-02-15T21:11:32Z",
"pushed_at": "2020-02-28T03:32:06Z",
"git_url": "git://github.com/microsoft/ai-architecture-template.git",
"ssh_url": "git@github.com:microsoft/ai-architecture-template.git",
"clone_url": "https://github.com/microsoft/ai-architecture-template.git",
"svn_url": "https://github.com/microsoft/ai-architecture-template",
"homepage": "",
"size": 120,
"stargazers_count": 2,
"watchers_count": 2,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 5,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 5,
"open_issues": 1,
"watchers": 2,
"default_branch": "master"
},
{
"id": 205398027,
"node_id": "MDEwOlJlcG9zaXRvcnkyMDUzOTgwMjc=",
"name": "ai-at-edge",
"full_name": "microsoft/ai-at-edge",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-at-edge",
"description": "Web pages for AI@Edge community",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-at-edge",
"forks_url": "https://api.github.com/repos/microsoft/ai-at-edge/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-at-edge/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-at-edge/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-at-edge/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-at-edge/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-at-edge/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-at-edge/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-at-edge/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-at-edge/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-at-edge/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-at-edge/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-at-edge/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-at-edge/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-at-edge/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-at-edge/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-at-edge/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-at-edge/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-at-edge/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-at-edge/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-at-edge/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-at-edge/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-at-edge/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-at-edge/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-at-edge/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-at-edge/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-at-edge/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-at-edge/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-at-edge/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-at-edge/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-at-edge/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-at-edge/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-at-edge/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-at-edge/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-at-edge/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-at-edge/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-at-edge/deployments",
"created_at": "2019-08-30T14:26:14Z",
"updated_at": "2020-05-08T00:11:38Z",
"pushed_at": "2021-07-13T05:19:13Z",
"git_url": "git://github.com/microsoft/ai-at-edge.git",
"ssh_url": "git@github.com:microsoft/ai-at-edge.git",
"clone_url": "https://github.com/microsoft/ai-at-edge.git",
"svn_url": "https://github.com/microsoft/ai-at-edge",
"homepage": null,
"size": 64969,
"stargazers_count": 2,
"watchers_count": 2,
"language": null,
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 6,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 6,
"open_issues": 2,
"watchers": 2,
"default_branch": "master"
},
{
"id": 157813180,
"node_id": "MDEwOlJlcG9zaXRvcnkxNTc4MTMxODA=",
"name": "ai-edu",
"full_name": "microsoft/ai-edu",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-edu",
"description": "AI education materials for Chinese students, teachers and IT professionals.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-edu",
"forks_url": "https://api.github.com/repos/microsoft/ai-edu/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-edu/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-edu/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-edu/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-edu/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-edu/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-edu/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-edu/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-edu/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-edu/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-edu/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-edu/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-edu/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-edu/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-edu/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-edu/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-edu/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-edu/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-edu/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-edu/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-edu/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-edu/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-edu/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-edu/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-edu/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-edu/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-edu/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-edu/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-edu/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-edu/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-edu/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-edu/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-edu/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-edu/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-edu/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-edu/deployments",
"created_at": "2018-11-16T04:36:22Z",
"updated_at": "2021-08-22T15:16:32Z",
"pushed_at": "2021-08-22T01:32:38Z",
"git_url": "git://github.com/microsoft/ai-edu.git",
"ssh_url": "git@github.com:microsoft/ai-edu.git",
"clone_url": "https://github.com/microsoft/ai-edu.git",
"svn_url": "https://github.com/microsoft/ai-edu",
"homepage": "https://microsoft.github.io/ai-edu/",
"size": 891417,
"stargazers_count": 9628,
"watchers_count": 9628,
"language": "HTML",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 2403,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 51,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 2403,
"open_issues": 51,
"watchers": 9628,
"default_branch": "master"
},
{
"id": 297446937,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTc0NDY5Mzc=",
"name": "ai-freezer-azure",
"full_name": "microsoft/ai-freezer-azure",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-freezer-azure",
"description": "Anomaly detecting scientific freezer monitor using and Adafruit Feather Huzzah32 and Azure Cognitive Services.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-freezer-azure",
"forks_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-freezer-azure/deployments",
"created_at": "2020-09-21T19:57:40Z",
"updated_at": "2020-12-16T15:42:11Z",
"pushed_at": "2020-10-24T00:33:22Z",
"git_url": "git://github.com/microsoft/ai-freezer-azure.git",
"ssh_url": "git@github.com:microsoft/ai-freezer-azure.git",
"clone_url": "https://github.com/microsoft/ai-freezer-azure.git",
"svn_url": "https://github.com/microsoft/ai-freezer-azure",
"homepage": "",
"size": 3022,
"stargazers_count": 1,
"watchers_count": 1,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 0,
"watchers": 1,
"default_branch": "main"
},
{
"id": 281254274,
"node_id": "MDEwOlJlcG9zaXRvcnkyODEyNTQyNzQ=",
"name": "ai-freezer-monitor",
"full_name": "microsoft/ai-freezer-monitor",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-freezer-monitor",
"description": "ESP32 Temperature monitor designed to work in ULT freezers.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-freezer-monitor",
"forks_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-freezer-monitor/deployments",
"created_at": "2020-07-21T00:21:03Z",
"updated_at": "2021-08-17T16:33:56Z",
"pushed_at": "2021-01-07T19:39:07Z",
"git_url": "git://github.com/microsoft/ai-freezer-monitor.git",
"ssh_url": "git@github.com:microsoft/ai-freezer-monitor.git",
"clone_url": "https://github.com/microsoft/ai-freezer-monitor.git",
"svn_url": "https://github.com/microsoft/ai-freezer-monitor",
"homepage": "",
"size": 9921,
"stargazers_count": 7,
"watchers_count": 7,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 1,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 0,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 1,
"open_issues": 0,
"watchers": 7,
"default_branch": "main"
},
{
"id": 88499076,
"node_id": "MDEwOlJlcG9zaXRvcnk4ODQ5OTA3Ng==",
"name": "AI-Immersion-Workshop",
"full_name": "microsoft/AI-Immersion-Workshop",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AI-Immersion-Workshop",
"description": "Workshop materials from the AI Immersion Workshop, for attendees to access and use",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop",
"forks_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/forks",
"keys_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/events",
"assignees_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/merges",
"archive_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AI-Immersion-Workshop/deployments",
"created_at": "2017-04-17T10:47:45Z",
"updated_at": "2021-04-20T16:08:20Z",
"pushed_at": "2017-09-26T22:54:46Z",
"git_url": "git://github.com/microsoft/AI-Immersion-Workshop.git",
"ssh_url": "git@github.com:microsoft/AI-Immersion-Workshop.git",
"clone_url": "https://github.com/microsoft/AI-Immersion-Workshop.git",
"svn_url": "https://github.com/microsoft/AI-Immersion-Workshop",
"homepage": null,
"size": 39496,
"stargazers_count": 65,
"watchers_count": 65,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 31,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 31,
"open_issues": 2,
"watchers": 65,
"default_branch": "master"
},
{
"id": 348053810,
"node_id": "MDEwOlJlcG9zaXRvcnkzNDgwNTM4MTA=",
"name": "ai-py-param-validation",
"full_name": "microsoft/ai-py-param-validation",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-py-param-validation",
"description": "Parameter Validation for Python method and function inputs.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-py-param-validation",
"forks_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-py-param-validation/deployments",
"created_at": "2021-03-15T16:58:40Z",
"updated_at": "2021-03-31T14:28:25Z",
"pushed_at": "2021-04-02T13:10:56Z",
"git_url": "git://github.com/microsoft/ai-py-param-validation.git",
"ssh_url": "git@github.com:microsoft/ai-py-param-validation.git",
"clone_url": "https://github.com/microsoft/ai-py-param-validation.git",
"svn_url": "https://github.com/microsoft/ai-py-param-validation",
"homepage": null,
"size": 72,
"stargazers_count": 1,
"watchers_count": 1,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 0,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 3,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 0,
"open_issues": 3,
"watchers": 1,
"default_branch": "main"
},
{
"id": 346882788,
"node_id": "MDEwOlJlcG9zaXRvcnkzNDY4ODI3ODg=",
"name": "ai-python",
"full_name": "microsoft/ai-python",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-python",
"description": "A collection of Python Packages for AI usecases",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-python",
"forks_url": "https://api.github.com/repos/microsoft/ai-python/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-python/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-python/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-python/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-python/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-python/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-python/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-python/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-python/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-python/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-python/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-python/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-python/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-python/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-python/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-python/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-python/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-python/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-python/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-python/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-python/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-python/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-python/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-python/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-python/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-python/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-python/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-python/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-python/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-python/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-python/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-python/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-python/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-python/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-python/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-python/deployments",
"created_at": "2021-03-12T00:35:52Z",
"updated_at": "2021-08-23T03:45:29Z",
"pushed_at": "2021-08-23T03:43:05Z",
"git_url": "git://github.com/microsoft/ai-python.git",
"ssh_url": "git@github.com:microsoft/ai-python.git",
"clone_url": "https://github.com/microsoft/ai-python.git",
"svn_url": "https://github.com/microsoft/ai-python",
"homepage": "",
"size": 482,
"stargazers_count": 17,
"watchers_count": 17,
"language": "Dockerfile",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 9,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 12,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 9,
"open_issues": 12,
"watchers": 17,
"default_branch": "main"
},
{
"id": 146635422,
"node_id": "MDEwOlJlcG9zaXRvcnkxNDY2MzU0MjI=",
"name": "AI-Robot-Challenge-Lab",
"full_name": "microsoft/AI-Robot-Challenge-Lab",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AI-Robot-Challenge-Lab",
"description": "AI Robot Challenge Lab",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab",
"forks_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/forks",
"keys_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/events",
"assignees_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/merges",
"archive_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AI-Robot-Challenge-Lab/deployments",
"created_at": "2018-08-29T17:31:25Z",
"updated_at": "2021-08-10T13:22:17Z",
"pushed_at": "2019-11-14T10:34:07Z",
"git_url": "git://github.com/microsoft/AI-Robot-Challenge-Lab.git",
"ssh_url": "git@github.com:microsoft/AI-Robot-Challenge-Lab.git",
"clone_url": "https://github.com/microsoft/AI-Robot-Challenge-Lab.git",
"svn_url": "https://github.com/microsoft/AI-Robot-Challenge-Lab",
"homepage": null,
"size": 5375,
"stargazers_count": 51,
"watchers_count": 51,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 31,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 1,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 31,
"open_issues": 1,
"watchers": 51,
"default_branch": "master"
},
{
"id": 118039028,
"node_id": "MDEwOlJlcG9zaXRvcnkxMTgwMzkwMjg=",
"name": "ai-school-custom-vision-service-intro",
"full_name": "microsoft/ai-school-custom-vision-service-intro",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-school-custom-vision-service-intro",
"description": "This is an introduction to how to get started using the Custom Vision Service to generate custom models using the web interface and the SDK.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro",
"forks_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-school-custom-vision-service-intro/deployments",
"created_at": "2018-01-18T21:16:04Z",
"updated_at": "2021-04-20T16:13:07Z",
"pushed_at": "2018-01-19T05:06:33Z",
"git_url": "git://github.com/microsoft/ai-school-custom-vision-service-intro.git",
"ssh_url": "git@github.com:microsoft/ai-school-custom-vision-service-intro.git",
"clone_url": "https://github.com/microsoft/ai-school-custom-vision-service-intro.git",
"svn_url": "https://github.com/microsoft/ai-school-custom-vision-service-intro",
"homepage": "",
"size": 5667,
"stargazers_count": 30,
"watchers_count": 30,
"language": "C#",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 17,
"mirror_url": null,
"archived": true,
"disabled": false,
"open_issues_count": 2,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 17,
"open_issues": 2,
"watchers": 30,
"default_branch": "master"
},
{
"id": 292170212,
"node_id": "MDEwOlJlcG9zaXRvcnkyOTIxNzAyMTI=",
"name": "AI-System",
"full_name": "microsoft/AI-System",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/AI-System",
"description": "System for AI Education Resource.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/AI-System",
"forks_url": "https://api.github.com/repos/microsoft/AI-System/forks",
"keys_url": "https://api.github.com/repos/microsoft/AI-System/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/AI-System/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/AI-System/teams",
"hooks_url": "https://api.github.com/repos/microsoft/AI-System/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/AI-System/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/AI-System/events",
"assignees_url": "https://api.github.com/repos/microsoft/AI-System/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/AI-System/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/AI-System/tags",
"blobs_url": "https://api.github.com/repos/microsoft/AI-System/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/AI-System/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/AI-System/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/AI-System/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/AI-System/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/AI-System/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/AI-System/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/AI-System/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/AI-System/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/AI-System/subscription",
"commits_url": "https://api.github.com/repos/microsoft/AI-System/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/AI-System/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/AI-System/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/AI-System/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/AI-System/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/AI-System/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/AI-System/merges",
"archive_url": "https://api.github.com/repos/microsoft/AI-System/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/AI-System/downloads",
"issues_url": "https://api.github.com/repos/microsoft/AI-System/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/AI-System/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/AI-System/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/AI-System/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/AI-System/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/AI-System/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/AI-System/deployments",
"created_at": "2020-09-02T03:35:43Z",
"updated_at": "2021-08-22T15:36:06Z",
"pushed_at": "2021-08-13T08:09:20Z",
"git_url": "git://github.com/microsoft/AI-System.git",
"ssh_url": "git@github.com:microsoft/AI-System.git",
"clone_url": "https://github.com/microsoft/AI-System.git",
"svn_url": "https://github.com/microsoft/AI-System",
"homepage": "https://microsoft.github.io/AI-System/",
"size": 258305,
"stargazers_count": 987,
"watchers_count": 987,
"language": "Python",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 118,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 9,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 118,
"open_issues": 9,
"watchers": 987,
"default_branch": "main"
},
{
"id": 218328252,
"node_id": "MDEwOlJlcG9zaXRvcnkyMTgzMjgyNTI=",
"name": "ai-utilities",
"full_name": "microsoft/ai-utilities",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai-utilities",
"description": "SAMPLE: Microsoft AI Azure Machine Learning Utilities and Wrappers.",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai-utilities",
"forks_url": "https://api.github.com/repos/microsoft/ai-utilities/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai-utilities/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai-utilities/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai-utilities/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai-utilities/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai-utilities/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai-utilities/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai-utilities/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai-utilities/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai-utilities/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai-utilities/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai-utilities/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai-utilities/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai-utilities/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai-utilities/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai-utilities/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai-utilities/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai-utilities/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai-utilities/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai-utilities/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai-utilities/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai-utilities/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai-utilities/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai-utilities/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai-utilities/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai-utilities/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai-utilities/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai-utilities/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai-utilities/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai-utilities/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai-utilities/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai-utilities/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai-utilities/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai-utilities/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai-utilities/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai-utilities/deployments",
"created_at": "2019-10-29T16:05:17Z",
"updated_at": "2021-04-02T04:31:56Z",
"pushed_at": "2020-06-17T05:16:40Z",
"git_url": "git://github.com/microsoft/ai-utilities.git",
"ssh_url": "git@github.com:microsoft/ai-utilities.git",
"clone_url": "https://github.com/microsoft/ai-utilities.git",
"svn_url": "https://github.com/microsoft/ai-utilities",
"homepage": "",
"size": 15438,
"stargazers_count": 10,
"watchers_count": 10,
"language": "Jupyter Notebook",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": true,
"forks_count": 6,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 5,
"license": {
"key": "mit",
"name": "MIT License",
"spdx_id": "MIT",
"url": "https://api.github.com/licenses/mit",
"node_id": "MDc6TGljZW5zZTEz"
},
"forks": 6,
"open_issues": 5,
"watchers": 10,
"default_branch": "master"
},
{
"id": 343997302,
"node_id": "MDEwOlJlcG9zaXRvcnkzNDM5OTczMDI=",
"name": "ai.ed",
"full_name": "microsoft/ai.ed",
"private": false,
"owner": {
"login": "microsoft",
"id": 6154722,
"node_id": "MDEyOk9yZ2FuaXphdGlvbjYxNTQ3MjI=",
"avatar_url": "https://avatars.githubusercontent.com/u/6154722?v=4",
"gravatar_id": "",
"url": "https://api.github.com/users/microsoft",
"html_url": "https://github.com/microsoft",
"followers_url": "https://api.github.com/users/microsoft/followers",
"following_url": "https://api.github.com/users/microsoft/following{/other_user}",
"gists_url": "https://api.github.com/users/microsoft/gists{/gist_id}",
"starred_url": "https://api.github.com/users/microsoft/starred{/owner}{/repo}",
"subscriptions_url": "https://api.github.com/users/microsoft/subscriptions",
"organizations_url": "https://api.github.com/users/microsoft/orgs",
"repos_url": "https://api.github.com/users/microsoft/repos",
"events_url": "https://api.github.com/users/microsoft/events{/privacy}",
"received_events_url": "https://api.github.com/users/microsoft/received_events",
"type": "Organization",
"site_admin": false
},
"html_url": "https://github.com/microsoft/ai.ed",
"description": "AI for (programming) EDucation",
"fork": false,
"url": "https://api.github.com/repos/microsoft/ai.ed",
"forks_url": "https://api.github.com/repos/microsoft/ai.ed/forks",
"keys_url": "https://api.github.com/repos/microsoft/ai.ed/keys{/key_id}",
"collaborators_url": "https://api.github.com/repos/microsoft/ai.ed/collaborators{/collaborator}",
"teams_url": "https://api.github.com/repos/microsoft/ai.ed/teams",
"hooks_url": "https://api.github.com/repos/microsoft/ai.ed/hooks",
"issue_events_url": "https://api.github.com/repos/microsoft/ai.ed/issues/events{/number}",
"events_url": "https://api.github.com/repos/microsoft/ai.ed/events",
"assignees_url": "https://api.github.com/repos/microsoft/ai.ed/assignees{/user}",
"branches_url": "https://api.github.com/repos/microsoft/ai.ed/branches{/branch}",
"tags_url": "https://api.github.com/repos/microsoft/ai.ed/tags",
"blobs_url": "https://api.github.com/repos/microsoft/ai.ed/git/blobs{/sha}",
"git_tags_url": "https://api.github.com/repos/microsoft/ai.ed/git/tags{/sha}",
"git_refs_url": "https://api.github.com/repos/microsoft/ai.ed/git/refs{/sha}",
"trees_url": "https://api.github.com/repos/microsoft/ai.ed/git/trees{/sha}",
"statuses_url": "https://api.github.com/repos/microsoft/ai.ed/statuses/{sha}",
"languages_url": "https://api.github.com/repos/microsoft/ai.ed/languages",
"stargazers_url": "https://api.github.com/repos/microsoft/ai.ed/stargazers",
"contributors_url": "https://api.github.com/repos/microsoft/ai.ed/contributors",
"subscribers_url": "https://api.github.com/repos/microsoft/ai.ed/subscribers",
"subscription_url": "https://api.github.com/repos/microsoft/ai.ed/subscription",
"commits_url": "https://api.github.com/repos/microsoft/ai.ed/commits{/sha}",
"git_commits_url": "https://api.github.com/repos/microsoft/ai.ed/git/commits{/sha}",
"comments_url": "https://api.github.com/repos/microsoft/ai.ed/comments{/number}",
"issue_comment_url": "https://api.github.com/repos/microsoft/ai.ed/issues/comments{/number}",
"contents_url": "https://api.github.com/repos/microsoft/ai.ed/contents/{+path}",
"compare_url": "https://api.github.com/repos/microsoft/ai.ed/compare/{base}...{head}",
"merges_url": "https://api.github.com/repos/microsoft/ai.ed/merges",
"archive_url": "https://api.github.com/repos/microsoft/ai.ed/{archive_format}{/ref}",
"downloads_url": "https://api.github.com/repos/microsoft/ai.ed/downloads",
"issues_url": "https://api.github.com/repos/microsoft/ai.ed/issues{/number}",
"pulls_url": "https://api.github.com/repos/microsoft/ai.ed/pulls{/number}",
"milestones_url": "https://api.github.com/repos/microsoft/ai.ed/milestones{/number}",
"notifications_url": "https://api.github.com/repos/microsoft/ai.ed/notifications{?since,all,participating}",
"labels_url": "https://api.github.com/repos/microsoft/ai.ed/labels{/name}",
"releases_url": "https://api.github.com/repos/microsoft/ai.ed/releases{/id}",
"deployments_url": "https://api.github.com/repos/microsoft/ai.ed/deployments",
"created_at": "2021-03-03T04:07:29Z",
"updated_at": "2021-07-07T22:27:36Z",
"pushed_at": "2021-08-19T00:57:25Z",
"git_url": "git://github.com/microsoft/ai.ed.git",
"ssh_url": "git@github.com:microsoft/ai.ed.git",
"clone_url": "https://github.com/microsoft/ai.ed.git",
"svn_url": "https://github.com/microsoft/ai.ed",
"homepage": null,
"size": 28137,
"stargazers_count": 10,
"watchers_count": 10,
"language": "TypeScript",
"has_issues": true,
"has_projects": true,
"has_downloads": true,
"has_wiki": true,
"has_pages": false,
"forks_count": 1,
"mirror_url": null,
"archived": false,
"disabled": false,
"open_issues_count": 3,
"license": {
"key": "other",
"name": "Other",
"spdx_id": "NOASSERTION",
"url": null,
"node_id": "MDc6TGljZW5zZTA="
},
"forks": 1,
"open_issues": 3,
"watchers": 10,
"default_branch": "main"
},
]